import _ from "lodash";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef, useMemo } from "react";
import ScreenPanel from "Post/routes/CreatePost/components/ScreenPanel";
import classes from "./ManageStudentActivity.scss";
import CreatePost from "Post/routes/CreatePost/CreatePost";
import moment from "moment";
import TaggedFolders from "Post/components/TaggedFolders";
import MultipleAttachmentsSlider from "Post/components/MultipleAttachmentsSlider";
import { ManageFoldersModal } from "Post/components";
import {
  TagCard,
  ActivitySelector,
  PostPreview,
  TimePicker,
} from "./components";
import { colors } from "Constants";
import { CreateDropDown } from "Attachment";
import {
  IconButton,
  TextAreaInput,
  Tabs,
  Avatar,
  Button,
  Modal,
  Checkbox,
  Alert,
  Tooltip,
  ButtonDisclosure,
  SplitButtonDropdown,
  Dropdown,
  DropdownMenu,
  Tag,
} from "@toddle-edu/ds-web";
import {
  EyeOutlined,
  FamilyOutlined,
  FolderOutlined,
  GlobeOutlined,
  LockOutlined,
  PencilLineOutlined,
  PublishOutlined,
  StudentAddOutlined,
  StudentOutlined,
  ApprovalTickOutlined,
  WarningTriangleFilled,
  CalendarScheduleOutlined,
  SettingsOutlined,
  AddCircleOutlined,
  TeacherShareOutlined,
  FolderFilled,
  RefreshArrowOutlined,
  TickCircleFilled,
  CommentAddOutlined,
  DownloadOutlined,
  DeleteOutlined,
} from "@toddle-edu/ds-icons";
import { graphql, compose } from "lib/apolloClient";
import { connect } from "react-redux";
import ScrollableCarousel from "UIComponents/ScrollableCarousel";
import withLoader from "UIComponents/GqlWithLoader";
import I18nHOC from "UIComponents/I18nHOC";
import DialogueBoxV3 from "UIComponents/DialogueBoxV3";
import AudioWaveformPlayer from "UIComponents/AudioWaveformPlayer";
import TheatreModeV2 from "UIComponents/TheatreModeV2";

import { getStudentActivityCriteriaSetsQuery } from "Post/modules/ActivityTrackingQuery";
import {
  getStudentActivityCriteriaSetsFromCache,
  getCourseFilteredStudentFromCache,
} from "Post/modules/PostGraphqlHelpers";
import {
  removeAttachmentFromActivities,
  removeSingleAttachmentFromActivity,
  updateAllActivities,
  updateAllActivityAttachments,
  updateSingleActivity,
  updateSingleActivityAttachments,
  getLocaleForOverrideModal,
  isStudentDataEqual,
  ACTIVITY_VALUE_STATUS_ALL,
  getCombinedDateAndTimeMoment,
  isPortfolioParityEnabled,
  isGlobalHeaderOnMultipleScreensEnabled,
  getFormattedUserNameWithoutPronoun,
  isPortfolioReviewSetupEnabledAndIsJournalRoute,
  isPortfolioReviewSetupEnabled,
  isPortfolioReviewSetupEnabledAndIsReviewRoute,
} from "Post/utils";
import { AVATAR_COLORS } from "Constants/colorConstants";
import {
  hashString,
  getMemoizedFunction,
  getUpdatedArchivedFilters,
  generateRandomId,
  onEnterOrSpaceKeyDown,
} from "Utils";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import {
  ACTIVITY_NAP,
  ACTIVITY_FOOD,
  ACTIVITY_TOILET,
  COLORS_MAPPING_FOR_TAG,
  COLORS_MAPPING_FOR_CHIP,
  updatePostStatusV2,
} from "Post/modules/PostModule";
import {
  setToastMsg,
  getUserInfo,
  enableGlobalHeader,
  disableGlobalHeader,
} from "Login/modules/LoginModule";

import { getFormattedUserName } from "Utils/GetFormattedUserName";
import { ASC } from "Constants/stringConstants";
import {
  getSelectedCurriculumId,
  getDefaultStudentNameOrderPreference,
  getSelectedAcademicYearId,
  getCurrentAcademicYear,
} from "modules/CommonSelectors";
import { getSettingValue } from "modules/PermissionModule";
import { downloadFromUrl, removeProgressElement } from "modules/Services";
import { updateSettings } from "modules/ConfigurationThunks";
import SchedulePostModal from "AppComponents/Post/components/SchedulePostModal";

import { getCourseFolders } from "Journal/modules/JournalQuery";
import { getCourseFoldersFromCache } from "Journal/modules/JournalGraphqlHelpers";
import TaggedFoldersV2 from "Post/components/TaggedFolders/TaggedFoldersV2";
import { ArrowContainer, Popover } from "@toddle-edu/react-tiny-popover";
import classnames from "classnames";
import { getCourseFilteredStudentQuery } from "AppComponents/Post/modules/PostQuery";

import { updatePostStatus } from "Journal/modules/JournalModule";

import { getConfigurationQuery } from "Login/routes/Administrator/routes/Settings/routes/PortfolioManager/routes/TeacherPortfolio/modules/TeacherPortfolioQueries";
import { createConfigurationFilters } from "Login/routes/Administrator/routes/Settings/routes/PortfolioManager/routes/TeacherPortfolio/modules/TeacherPortfolioModule";
import ReorderAttachment from "../ManageSubjectJournalPost/components/ReorderAttachment";
import EditAttachmentModal from "../ManageSubjectJournalPost/components/EditAttachmentModal";

const getNonAudioAttachments = attachments => {
  return _.filter(attachments, attachment => attachment?.type !== "AUDIO");
};

const DIALOGS_INFO = {
  DELETE: {
    title: "journal:delete_dialog_title",
    message: "journal:delete_dialog_message",
    confirmButtonText: "common:delete_confirm",
    cancelButtonText: "common:cancel",
    button1Props: {
      variant: "outlined-subtle",
      size: "large",
    },
    button2Props: {
      variant: "destructive",
      size: "large",
    },
    size: "auto",
  },

  APPROVE: {
    title: "journal:approve_post",
    message: "journal:approve_msg",
    confirmButtonText: "common:approve",
  },
  APPROVE_WITH_COMMENT: {
    title: "journal:approve_with_comment",
    message: "journal:approve_with_comment_msg",
    titleSubText: ({ t }) => t("journal:approve_with_comment_msg"),
    confirmButtonText: "common:approve",
    isPromptBox: true,
    size: "auto",
    promptBoxType: "TextAreaInput",
    warningTextStyles: {
      color: colors.textDefault,
      fontSize: "1.6rem",
    },
    promptDetail: ({ t }) => ({
      placeholder: t("journal:enter_comment_here"),
      checkValidation: true,
      promptText: "",
    }),
    textAreaRows: 3,
    button1Props: {
      variant: "outlined-subtle",
      size: "large",
    },
    button2Props: {
      size: "large",
      variant: "progressive",
    },
    headerStyles: { alignItems: "flex-start" },
  },
  DISCARD: {
    title: "journal:discard_dialog_title",
    message: "journal:discard_dialog_message",
    confirmButtonText: "journal:publish",
  },
  APPROVE_ALL: {
    title: "journal:approve_all_posts",
    message: "journal:approve_all_posts_msg",
    confirmButtonText: "journal:approve_all",
    button1Props: {
      variant: "outlined-subtle",
      size: "large",
    },
    button2Props: {
      size: "large",
      variant: "progressive",
    },
    size: "auto",
  },
  REJECT_ALL: {
    title: "journal:return_all_posts",
    message: "journal:return_all_posts_msg",
    confirmButtonText: "journal:return_all",
    button1Props: {
      variant: "outlined-subtle",
      size: "large",
    },
    button2Props: {
      variant: "destructive",
      size: "large",
    },
    size: "auto",
    textAreaRows: 3,
  },
  REJECT_POST: {
    title: "journal:return_post",
    message: "common:approve",
    titleSubText: ({ t, name }) =>
      t("journal:return_with_note_msg", { label: name }),
    confirmButtonText: "common:return",
    isPromptBox: true,
    size: "auto",
    promptBoxType: "TextAreaInput",
    promptDetail: ({ t }) => ({
      label: t("journal:return_with_note"),
      placeholder: t("journal:enter_note_here"),
      checkValidation: false,
      promptText: "",
    }),
    warningTextStyles: {
      color: colors.textDefault,
      fontSize: "1.6rem",
    },
    button1Props: {
      variant: "outlined-subtle",
      size: "large",
    },
    button2Props: {
      variant: "destructive",
      size: "large",
    },
    headerStyles: { alignItems: "flex-start" },
  },
};

const styles = {
  containerStyle: {
    padding: 0,
  },
  footerContainerStyle: {
    height: "80px",
    boxShadow: "none",
    borderTop: `1px solid ${colors.neutral700}`,
  },
  sharedWithContainerStyle: {
    paddingBlock: "16px",
  },
  sharedWithFlexContainerStyle: {
    paddingInline: "24px",
  },
  customDeleteButtonStyle: {
    top: "20px",
  },
  tagStudentButton: {
    height: "48px",
    width: "48px",
  },
  audioCardStyle: {
    marginTop: "8px",
    marginInline: "32px",
    width: "unset",
    marginBottom: "16px",
  },
  audioActionButtonStyle: {
    alignSelf: "center",
    display: "flex",
    justifyContent: "space-between",
  },
  toolbarHeaderStyles: { gridTemplateColumns: `repeat(3,33%)` },
  sharedWithStyle: {
    cursor: "pointer",
  },
};

const DROP_DOWN_OPTIONS = [
  { key: "capture_image", label: "common:capture_image" },
  { key: "capture_video", label: "common:capture_video" },
  { key: "capture_voice", label: "common:record_voice" },
  { key: "add_google_drive", label: "common:add_google_drive" },
  { key: "add_one_drive", label: "common:add_one_drive" },
  { key: "upload_device", label: "common:upload_device" },
];

const BLANK_ARRAY = [];
const BLANK_OBJECT = {};
const DROP_DOWN_OPTIONS_V2 = [
  {
    key: "upload_image",
    label: "journal:upload_photo_video_from_device",
    accept: [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/heic",
      "image/heif",
      "video/mp4",
      "video/avi",
      "video/wmv",
    ],
    perm: "MEDIA",
  },
  {
    key: "capture_voice",
    label: "journal:add_audio",
    reloadText: "journal:restart",
    submitText: "journal:add_to_post",
    perm: "VOICE",
  },
  { key: "capture_image", label: "common:capture_image", perm: "PHOTO" },
  { key: "capture_video", label: "common:capture_video", perm: "VIDEO" },
  { key: "add_link", label: "common:add_link", perm: "LINK" },
  { key: "upload_device", label: "common:upload_device", perm: "FILE" },
  { key: "add_google_drive", label: "common:add_google_drive", perm: "FILE" },
  { key: "add_one_drive", label: "common:add_one_drive", perm: "FILE" },
];

const DROP_DOWN_OPTIONS_AUDIO_DISABLED = _.map(DROP_DOWN_OPTIONS_V2, function (
  option
) {
  if (option.key === "capture_voice") {
    return _.assign({}, option, {
      label: "journal:max_audio_limit_warning",
      disabled: true,
    });
  } else return option;
});

const DROP_DOWN_OPTIONS_V2_DISABLED = _.map(DROP_DOWN_OPTIONS_V2, function (
  option
) {
  return _.assign({}, option, {
    label: "journal:max_attachment_limit_warning",
    disabled: true,
  });
});

const isTimeAfter = (time1, time2) => {
  const time1Minutes = time1.minutes() + time1.hours() * 60;
  const time2Minutes = time2.minutes() + time2.hours() * 60;
  return time1Minutes >= time2Minutes;
};

const getActivityName = activityType => {
  switch (activityType) {
    case ACTIVITY_NAP:
      return "common:nap";
    case ACTIVITY_FOOD:
      return "common:food";
    case ACTIVITY_TOILET:
      return "common:toilet";
    default:
      return "";
  }
};

const FooterComponent = React.memo(props => {
  const {
    onPublishClick,
    onDraftClick,
    state,
    mode,
    t,
    onCloseClick,
    disabled,
    scheduledPublishedAt,
    setScheduledPublishedAt,
    togglePostScheduleModal,
    updatePost,
    setToastMsg,
  } = props;

  const publishDropdownOptions = [
    {
      label: t(
        mode == "edit" && state !== "DRAFT"
          ? "common:update"
          : "journal:publish"
      ),
      key: "PUBLISH_POST",
      icon: <PublishOutlined />,
    },
    {
      label: t("journal:select_date_and_time"),
      key: "SCHEDULE_POST",
      icon: <CalendarScheduleOutlined />,
    },
  ];

  const scheduleDropdownOptions = [
    {
      label: t("common:edit_with_label", {
        label: t("common:scheduled_date"),
        lowercase: true,
      }),
      key: "EDIT_SCHEDULE_DATE",
    },
    {
      label: t("common:unschedule"),
      key: "UNSCHEDULE_POST",
    },
  ];

  const onPublishDropdownOptionClick = value => {
    switch (_.get(value, "key", "")) {
      case "PUBLISH_POST":
        onPublishClick();
        break;

      case "SCHEDULE_POST":
        togglePostScheduleModal(true);
        break;

      case "EDIT_SCHEDULE_DATE":
        togglePostScheduleModal(true);
        break;

      case "UNSCHEDULE_POST":
        setScheduledPublishedAt(null);
        updatePost({
          publishedAt: undefined,
          state: mode !== "create" ? "PUBLISHED" : "DRAFT",
        });
        setToastMsg({
          msg: "toastMsgs:post_unscheduled_successfully",
          type: "success",
        });
        break;
      default:
        break;
    }
  };

  return (
    <div className={classes.footerButtonContainer}>
      <Button
        variant={"outlined"}
        size="large"
        onClick={onDraftClick}
        disabled={disabled}
        testId="journal-postcreation-saveasdraft"
      >
        {t("common:save_as_draft")}
      </Button>

      <div className={classes.footerButtonRightContainer}>
        {state === "SCHEDULED" || !_.isEmpty(scheduledPublishedAt) ? (
          <Dropdown
            overlay={
              <DropdownMenu
                options={scheduleDropdownOptions}
                onClick={onPublishDropdownOptionClick}
                style={{ minWidth: "184px" }}
                showSelection={true}
                testId="journal-feed-postcreation"
              />
            }
            placement={"topRight"}
            variant={"plain"}
          >
            <ButtonDisclosure
              variant="plain"
              size={"large"}
              style={{ padding: "8px" }}
            >
              {t(
                moment(scheduledPublishedAt).isAfter(moment())
                  ? "common:scheduled_for_with_label"
                  : "journal:set_for_with_label",
                {
                  label:
                    moment(scheduledPublishedAt).format("MMM DD YYYY") +
                    ", " +
                    moment(scheduledPublishedAt).format("hh:mm A"),
                }
              )}
            </ButtonDisclosure>
          </Dropdown>
        ) : null}

        <ConditionalWrapper
          condition={
            _.includes(["PUBLISHED", "DRAFT"], state) &&
            _.isEmpty(scheduledPublishedAt)
          }
          wrapper={
            <SplitButtonDropdown
              overlay={
                <DropdownMenu
                  options={publishDropdownOptions}
                  onClick={onPublishDropdownOptionClick}
                  style={{ minWidth: "184px" }}
                  showSelection={true}
                  testId="journal-feed-postcreation"
                />
              }
              placement={"topRight"}
              variant={"progressive"}
              disabled={disabled}
            />
          }
          type="wrapperAsElement"
        >
          <Button
            variant="progressive"
            size={"large"}
            icon={<PublishOutlined />}
            onClick={onPublishClick}
            disabled={disabled}
            testId="journal-postcreation-publish"
          >
            {state == "DRAFT" || mode == "create"
              ? moment(scheduledPublishedAt).isAfter(moment())
                ? t("common:schedule")
                : t("journal:publish")
              : t("common:update")}
          </Button>
        </ConditionalWrapper>
      </div>
    </div>
  );
});
FooterComponent.displayName = "Footer";

const HeaderRightComponent = React.memo(props => {
  const {
    onPublishClick,
    onDraftClick,
    state,
    mode,
    t,
    onCloseClick,
    disabled,
    scheduledPublishedAt,
    setScheduledPublishedAt,
    togglePostScheduleModal,
    updatePost,
    setToastMsg,
    isUploading,
    selectedStudents,
    studentActivityData,
    setIsPostPreviewOn,
    onSendForApprovalClick,
    isUserAllowedToPublishPost,
    isPostCtaDisabled,
    userType,
    onDialogActionClick,
    updatePostStatusV2,
    postDetails,
    isGlobalHeaderEnabled,
    userId,
  } = props;

  const onPostActionClick = async ({
    id,
    action,
    createdByName = "",
    isAddLEToJournal,
  }) => {
    switch (action) {
      case "APPROVE":
        updatePostStatusV2("PUBLISHED");
        _.isFunction(onCloseClick) && onCloseClick();
        break;
      case "APPROVE_ALL":
      case "APPROVE_WITH_COMMENT":
      case "REJECT_POST":
        onDialogActionClick({ id, action, createdByName });
        break;
    }
  };

  const publishDropdownOptions = [
    {
      label: t(
        mode == "edit" && state !== "DRAFT"
          ? "common:update"
          : "journal:publish"
      ),
      key: "PUBLISH_POST",
      icon: <PublishOutlined />,
    },
    {
      label: t("journal:select_date_and_time"),
      key: "SCHEDULE_POST",
      icon: <CalendarScheduleOutlined />,
    },
  ];

  const scheduleDropdownOptions = [
    {
      label: t("common:edit_with_label", {
        label: t("common:scheduled_date"),
        lowercase: true,
      }),
      key: "EDIT_SCHEDULE_DATE",
    },
    {
      label: t("common:unschedule"),
      key: "UNSCHEDULE_POST",
    },
  ];

  const onPublishDropdownOptionClick = value => {
    const isBackDatePost = !getCombinedDateAndTimeMoment(
      scheduledPublishedAt
    )?.isAfter(moment());
    switch (_.get(value, "key", "")) {
      case "PUBLISH_POST":
        onPublishClick();
        break;

      case "SCHEDULE_POST":
        togglePostScheduleModal(true);
        break;

      case "EDIT_SCHEDULE_DATE":
        togglePostScheduleModal(true);
        break;

      case "UNSCHEDULE_POST":
        if (isPortfolioReviewSetupEnabledAndIsReviewRoute()) {
          setScheduledPublishedAt(null);
          setToastMsg({
            msg: isBackDatePost
              ? "toastMsgs:date_and_time_removed"
              : "toastMsgs:post_unscheduled_successfully",
            type: "success",
          });
          updatePost({
            state: "IN_APPROVAL",
            publishedAt: undefined,
          });
        } else {
          setScheduledPublishedAt(null);
          updatePost({
            publishedAt: undefined,
            state: mode !== "create" ? "PUBLISHED" : "DRAFT",
          });
          setToastMsg({
            msg: "toastMsgs:post_unscheduled_successfully",
            type: "success",
          });
        }
        break;
      default:
        break;
    }
  };

  const onSendForApprovalButtonClick = () => {
    onSendForApprovalClick();
  };
  const approveDropdownOptions = [
    {
      label: t("journal:approve_with_comment"),
      key: "APPROVE_WITH_COMMENT",
      icon: <CommentAddOutlined />,
    },
    ...(isPortfolioReviewSetupEnabledAndIsReviewRoute()
      ? [
          {
            label: t("journal:select_date_and_time"),
            key: "SCHEDULE_POST",
            icon: <CalendarScheduleOutlined />,
          },
        ]
      : []),
  ];
  const onApproveDropdownOptionClick = value => {
    switch (_.get(value, "key", "")) {
      case "APPROVE_WITH_COMMENT":
        onPostActionClick({
          id: _.get(postDetails, "id", null),
          action: "APPROVE_WITH_COMMENT",
          createdByName: _.get(postDetails, "createdBy.firstName", ""),
        });
        break;
      case "SCHEDULE_POST":
        if (_.isFunction(togglePostScheduleModal))
          togglePostScheduleModal(true);
        break;
    }
  };

  const canUserEditPost =
    _.get(postDetails, "createdBy.id") === userId || mode !== "edit"
      ? true
      : isUserAllowedToPublishPost;
  return (
    <div className={classes.headerRightContainer}>
      {(isPortfolioReviewSetupEnabledAndIsJournalRoute()
        ? isUserAllowedToPublishPost
        : true) &&
      (state === "SCHEDULED" || !_.isEmpty(scheduledPublishedAt)) ? (
        <Dropdown
          overlay={
            <DropdownMenu
              options={scheduleDropdownOptions}
              onClick={onPublishDropdownOptionClick}
              style={{ minWidth: "184px" }}
              showSelection={true}
              testId="journal-feed-postcreation"
            />
          }
          placement={"topRight"}
          variant={"plain"}
        >
          <ButtonDisclosure
            dsVersion="2.0"
            variant="neutral"
            type="plain"
            size={"medium"}
            testId="journal-postcreation-schedule"
          >
            {t(
              moment(scheduledPublishedAt).isAfter(moment())
                ? "common:scheduled_for_with_label"
                : "journal:set_for_with_label",
              {
                label:
                  moment(scheduledPublishedAt).format("MMM DD YYYY") +
                  ", " +
                  moment(scheduledPublishedAt).format("hh:mm A"),
              }
            )}
          </ButtonDisclosure>
        </Dropdown>
      ) : null}
      <Button
        onClick={() => setIsPostPreviewOn(true)}
        icon={<EyeOutlined />}
        size={isGlobalHeaderEnabled ? "medium" : ""}
        dsVersion={isGlobalHeaderEnabled ? "2.0" : "1.0"}
        variant={isGlobalHeaderEnabled ? "neutral" : "outlined-subtle"}
        type={isGlobalHeaderEnabled && !disabled ? "outlined" : "fill"}
        disabled={
          _.isEmpty(selectedStudents) ||
          _.isEmpty(_.omit(studentActivityData, "activityType")) ||
          isUploading
        }
        style={{ padding: "8px 10px" }}
        testId="journal-postcreation-preview"
      ></Button>
      {isPortfolioParityEnabled() &&
      (isPortfolioReviewSetupEnabledAndIsJournalRoute()
        ? _.get(postDetails, "createdBy.type", "staff") === "student"
        : true) &&
      state == "IN_APPROVAL" ? (
        <>
          <Button
            variant={isGlobalHeaderEnabled ? "neutral" : "outlined"}
            size="medium"
            onClick={() =>
              onPostActionClick({
                id: _.get(postDetails, "id", null),
                action: "REJECT_POST",
                createdByName: _.get(postDetails, "createdBy.firstName", ""),
                isAddLEToJournal: false,
              })
            }
            type={isGlobalHeaderEnabled ? "outlined" : "fill"}
            dsVersion={isGlobalHeaderEnabled ? "2.0" : "1.0"}
            testId={`journal-postcreation-${
              state == "DRAFT" || mode == "create"
                ? moment(scheduledPublishedAt).isAfter(moment())
                  ? "schedule"
                  : "publish"
                : "update"
            }`}
          >
            <RefreshArrowOutlined />
            <div className={classes.approveText}>{t("common:return")}</div>
          </Button>
          <SplitButtonDropdown
            overlay={
              <DropdownMenu
                options={approveDropdownOptions}
                onClick={onApproveDropdownOptionClick}
                testId="journal-feed-postcreation"
              />
            }
            placement={"bottomRight"}
            variant={"progressive"}
            dsVersion={isGlobalHeaderEnabled ? "2.0" : "1.0"}
          >
            <Button
              variant={"progressive"}
              size="medium"
              onClick={() =>
                onPostActionClick({
                  id: _.get(postDetails, "id", null),
                  action: "APPROVE",
                  createdByName: _.get(postDetails, "createdBy.firstName", ""),
                  isAddLEToJournal: false,
                })
              }
              style={{
                borderRadius: "8px 0px 0px 8px",
              }}
              dsVersion={isGlobalHeaderEnabled ? "2.0" : "1.0"}
            >
              <TickCircleFilled variant={"on"} />
              <div className={classes.approveText}>{t("common:approve")}</div>
            </Button>
          </SplitButtonDropdown>
        </>
      ) : (
        <>
          <Button
            size="medium"
            variant={isGlobalHeaderEnabled ? "neutral" : "outlined-subtle"}
            type={isGlobalHeaderEnabled && !disabled ? "outlined" : "fill"}
            dsVersion={isGlobalHeaderEnabled ? "2.0" : "1.0"}
            onClick={onDraftClick}
            disabled={disabled}
            icon={
              isPortfolioParityEnabled() ? (
                <ApprovalTickOutlined variant={"warning"} />
              ) : null
            }
            testId="journal-postcreation-saveasdraft"
          >
            {t("common:save_as_draft")}
          </Button>

          <div className={classes.footerButtonRightContainer}>
            {isPortfolioReviewSetupEnabledAndIsJournalRoute() &&
            !isUserAllowedToPublishPost &&
            userType === "staff" ? (
              <ConditionalWrapper
                type="wrapperAsElement"
                wrapper={
                  <Tooltip
                    placement={"bottomRight"}
                    tooltip={
                      isPortfolioReviewSetupEnabled() && !canUserEditPost
                        ? t("journal:you_dont_have_permission_publish_post")
                        : t("journal:reviewer_removed_tooltip")
                    }
                  />
                }
                condition={
                  isPostCtaDisabled ||
                  (isPortfolioReviewSetupEnabled() && !canUserEditPost)
                }
              >
                <Button
                  size={"medium"}
                  variant="progressive"
                  dsVersion={isGlobalHeaderEnabled ? "2.0" : "1.0"}
                  type={isGlobalHeaderEnabled ? "fill" : ""}
                  icon={<PublishOutlined />}
                  onClick={onSendForApprovalButtonClick}
                  disabled={
                    disabled ||
                    isPostCtaDisabled ||
                    (isPortfolioReviewSetupEnabled() && !canUserEditPost)
                  }
                >
                  {t("journal:send_for_approval")}
                </Button>
              </ConditionalWrapper>
            ) : (
              <ConditionalWrapper
                condition={
                  _.includes(["PUBLISHED", "DRAFT"], state) &&
                  _.isEmpty(scheduledPublishedAt)
                }
                wrapper={
                  <SplitButtonDropdown
                    overlay={
                      <DropdownMenu
                        options={publishDropdownOptions}
                        onClick={onPublishDropdownOptionClick}
                        style={{ minWidth: "184px" }}
                        showSelection={true}
                        testId="journal-feed-postcreation"
                      />
                    }
                    placement={"topRight"}
                    variant={isGlobalHeaderEnabled ? "primary" : "progressive"}
                    disabled={disabled}
                  />
                }
                type="wrapperAsElement"
              >
                <Button
                  variant={isGlobalHeaderEnabled ? "primary" : "progressive"}
                  size={"medium"}
                  dsVersion={isGlobalHeaderEnabled ? "2.0" : "1.0"}
                  type={isGlobalHeaderEnabled ? "fill" : ""}
                  icon={<PublishOutlined />}
                  onClick={onPublishClick}
                  disabled={disabled}
                  testId="journal-postcreation-publish"
                >
                  {state == "DRAFT" ||
                  mode == "create" ||
                  (state == "IN_APPROVAL" &&
                    userType === "staff" &&
                    isPortfolioReviewSetupEnabledAndIsJournalRoute())
                    ? moment(scheduledPublishedAt).isAfter(moment())
                      ? t("common:schedule")
                      : t("journal:publish")
                    : t("common:update")}
                </Button>
              </ConditionalWrapper>
            )}
          </div>
        </>
      )}
    </div>
  );
});
HeaderRightComponent.displayName = "Footer";

const OverrideModal = React.memo(props => {
  const operation = props?.overrideModalDetails?.operation;
  const onClose = () => {
    if (props?.overrideModalDetails?.property === "description") {
      props?.setDescription(
        _.get(props?.studentActivityData, "ALL.description.value")
      );
    }
    props?.setOverrideModalDetails({ showModal: false });
  };

  const onUpdateOrDelete = () => {
    props?.onConfirmOverride({
      updatedActivities: props?.overrideModalDetails?.data,
      locale: props?.overrideModalDetails?.notifyLocale,
      operation,
    });
    if (operation === "DELETE") {
      _.isFunction(props?.overrideModalDetails?.callbackFn) &&
        props?.overrideModalDetails?.callbackFn();
    }
  };
  return (
    <Modal
      width="440px"
      height="max-content"
      hasOverlay={true}
      shouldCloseOnOverlayClick={true}
      shouldCloseOnEsc={true}
      onClose={onClose}
      isOpen={true}
    >
      <Modal.Header
        title={props?.t("toastMsgs:update_details_of_all_students")}
        isClosable={true}
      />
      <Modal.Body>
        <div>
          <div className={classes.overrideDescription}>
            {props?.overrideModalDetails?.localeString}
          </div>
          <Checkbox
            size={"xx-small"}
            isChecked={props?.doNotShowOverrideModal}
            onChange={() =>
              props?.setDoNotShowOverrideModal(!props?.doNotShowOverrideModal)
            }
          >
            {props?.t("common:do_not_show_this_message_again")}
          </Checkbox>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.overrideModalFooter}>
          <Button
            dsVersion="2.0"
            variant="neutral"
            type="outlined"
            size={"large"}
            onClick={onClose}
            testId="journal-postcreation-overridecancel"
          >
            {props?.t("common:cancel")}
          </Button>
          <Button
            dsVersion="2.0"
            variant="destructive"
            size={"large"}
            onClick={onUpdateOrDelete}
            testId="journal-postcreation-overrideconfirm"
          >
            {props?.t("common:confirm_and_label", {
              label: props?.t(
                operation === "DELETE" ? "common:delete" : "common:update"
              ),
            })}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
});
OverrideModal.displayName = "OverrideModal";

const getSeletedFolders = props => {
  const { folders, addedFolders, removedFolders } = props;

  let selectedFolders = [];

  // If update post operation, then combine addedFolders and remove removedFolders to generate final set

  const selectedFoldersCopy = _.cloneDeep(folders) || [];
  const addedFoldersCopy = _.cloneDeep(addedFolders) || [];

  selectedFolders = _.uniqWith(
    [...selectedFoldersCopy, ...addedFoldersCopy],
    _.isEqual
  );

  _.remove(selectedFolders, folder => {
    return !!_.find(removedFolders, { id: folder.id });
  });
  return selectedFolders;
};
const getSelectedFoldersMemoized = getMemoizedFunction(getSeletedFolders);

const getBadgeIcon = type => {
  switch (type) {
    case "warning":
      return (
        <WarningTriangleFilled
          variant="critical"
          size="xxx-small"
          className={classes.warningBadge}
        />
      );
    case "individuallyRated":
      return (
        <div
          className={classes.individuallyRatedBadge}
          style={{ zIndex: isPortfolioParityEnabled() ? 1 : "" }}
        />
      );
    default:
      return null;
  }
};

const Badge = ({ type, children }) => {
  const badgeIcon = getBadgeIcon(type);

  return (
    <div className={classes.avatarContainer}>
      {badgeIcon}
      {children}
    </div>
  );
};

const TagFolderContentV2 = ({
  position,
  childRect,
  popoverRect,
  tagsOptions,
  attachedTags,
  onTagAdd,
  onNewTagAdd,
  setShowManageFoldersModal,
  setCreateFolderOnModalOpen,
  t,
  userType,
  closeTagInput,
}) => {
  const onFolderCreationClick = () => {
    onNewTagAdd();
  };

  const arrowContainerStyles = {
    arrowStyles: { opacity: 1, zIndex: 10, left: "24px" },
    overlayStyle: { zIndex: 2510 },
    overlayInnerStyles: { overflow: "hidden" },
  };

  return (
    <ArrowContainer
      position={position}
      childRect={childRect}
      popoverRect={popoverRect}
      arrowColor={colors.white}
      arrowStyle={arrowContainerStyles.arrowStyles}
      arrowSize={10}
      className="popover-arrow-container"
      arrowClassName="popover-arrow"
    >
      <div className={classes.folderPopoverContent}>
        <div className={classes.tagCloudContainer}>
          {_.map(tagsOptions, tag => {
            return (
              <Tooltip
                tooltip={tag?.text}
                placement="top"
                overlayStyle={arrowContainerStyles.arrowStyles}
                overlayInnerStyle={arrowContainerStyles.overlayInnerStyles}
              >
                <div
                  onClick={e => {
                    e?.stopPropagation();
                    onTagAdd(tag);
                  }}
                  className={classes.singleTagContainer}
                  data-test-id="journal-postcreation-tagfolderitem"
                >
                  <Tag
                    key={tag?.id}
                    size={"small"}
                    prefix={
                      <FolderFilled
                        style={{
                          color: _.get(
                            COLORS_MAPPING_FOR_CHIP,
                            tag?.color,
                            colors.surfaceDarkActive
                          ),
                          flexShrink: 0,
                        }}
                      />
                    }
                  >
                    <span>{tag?.text}</span>
                  </Tag>
                </div>
              </Tooltip>
            );
          })}
        </div>
        {_.size(tagsOptions) > 0 && userType === "staff" ? (
          <hr className={classes.divider} />
        ) : null}
        {userType === "staff" ? (
          <div className={classes.folderPopoverFooter}>
            <Button
              dsVersion="2.0"
              variant="progressive"
              type="inline"
              size="large"
              icon={<AddCircleOutlined />}
              onClick={onFolderCreationClick}
              testId="journal-postcreation-tagfoldercreate"
              className={classes.createNewFolderButton}
            >
              {t("common:create_new_folder")}
            </Button>
            <IconButton
              dsVersion="2.0"
              icon={<SettingsOutlined />}
              size={"small"}
              variant="neutral"
              type="plain"
              onClick={() => setShowManageFoldersModal(true)}
              className={classes.settingsButton}
              testId="journal-postcreation-tagfoldersetting"
              onBlur={closeTagInput}
            />
          </div>
        ) : null}
      </div>
    </ArrowContainer>
  );
};
TagFolderContentV2.displayName = "TagFolderContentV2";

const CustomTagsCard = props => {
  const {
    tags = [],
    updateFolderArray,
    updateFolderInArrayByName,
    attachedTags = [],
    t,
    showManageFoldersModal,
    setShowManageFoldersModal,
    setCreateFolderOnModalOpen,
    userType,
  } = props;
  const [tagInputFocus, setTagInputFocus] = useState(false);

  const tagsOptions = useMemo(
    () =>
      _.map(tags, tag => {
        return {
          text: _.get(tag, "name", ""),
          id: _.get(tag, "id", undefined),
          color: _.get(
            COLORS_MAPPING_FOR_TAG,
            _.get(tag, "color", "#686868"),
            "neutral"
          ),
          isNewTag: _.get(tag, "isNewTag", false),
        };
      }),
    [tags]
  );
  const tagsRef = useRef();
  const onTagAdd = value => {
    const existingTag = _.find(tagsOptions, tag => tag?.text == value?.text);
    const isUnique = _.isUndefined(
      _.find(attachedTags, tag => tag?.name == value?.text)
    );
    if (!_.isUndefined(existingTag)) {
      if (isUnique) {
        updateFolderArray([
          ...attachedTags,
          {
            id: _.get(existingTag, "id"),
            name: _.get(existingTag, "text", ""),
            color: _.get(existingTag, "color"),
            isNewTag: _.get(existingTag, "isNewTag", true),
          },
        ]);
      }
    } else {
      if (isUnique) {
        updateFolderArray([
          ...attachedTags,
          {
            id: value?.id,
            name: value?.text,
            color: _.sample(COLORS_MAPPING_FOR_CHIP),
            isNewTag: true,
          },
        ]);
      }
    }
    if (!_.isUndefined(tagsRef, "current.child.textInput.focus"))
      setTimeout(() => tagsRef?.current?.child?.textInput?.focus());
  };

  const onTagRemove = index => {
    if (index < _.size(attachedTags))
      updateFolderArray(
        _.filter(attachedTags, tag => tag?.id != attachedTags[index]?.id)
      );
  };

  const getQueryIndex = (query, item) => {
    return item["text"].toLowerCase().indexOf(query.toLowerCase());
  };

  const closeTagInput = () => {
    setTagInputFocus(false);
  };

  const [folderSearchText, setFolderSearchText] = useState("");
  const popoverContainerRef = useRef();
  const popoverParentRef = useRef();
  const onFolderSearchTextChange = e => {
    setFolderSearchText(e?.target?.value);
  };

  const onFolderSearchTextKeyDown = e => {
    if (e?.key === "Enter" && _.size(_.trim(folderSearchText)) > 0) {
      onNewTagAddLocal();
    }
  };

  const filteredTagsOptions = useMemo(() => {
    const attachedTagNames = _.map(attachedTags, tag => _.toLower(tag?.name));
    return _.filter(
      tagsOptions,
      tag =>
        _.includes(_.toLower(tag?.text), _.toLower(folderSearchText)) &&
        !_.includes(attachedTagNames, _.toLower(tag?.text))
    );
  }, [folderSearchText, tagsOptions, attachedTags]);

  const tagFolderInputClass = classnames({
    [classes.customFolderInput]: true,
    ["text-body-1"]: true,
  });

  const onTagAddLocal = tag => {
    onTagAdd(tag);
    setFolderSearchText("");
    popoverContainerRef?.current?.focus();
  };

  const onNewTagAddLocal = () => {
    onTagAdd({
      id: folderSearchText,
      text: folderSearchText,
      color: _.sample(COLORS_MAPPING_FOR_TAG),
    });
    setFolderSearchText("");
    popoverContainerRef?.current?.focus();
  };

  const onInputFocus = () => {
    setTagInputFocus(true);
  };
  const onInputBlur = () => {
    setTimeout(() => {
      setTagInputFocus(false || !!attachedTags);
    });
  };

  return (
    <div
      className={classes.tagsPopoverContainer}
      style={{ padding: isPortfolioParityEnabled() ? "24px 32px" : "" }}
    >
      <div
        className={classes.customFolderInputContainer}
        ref={popoverParentRef}
      >
        <TaggedFoldersV2
          folders={attachedTags}
          tagSize="small"
          isClosable={true}
          onClose={({ index }) => onTagRemove(index)}
        />
        <input
          ref={popoverContainerRef}
          placeholder={t("journal:type_or_create_folders")}
          onChange={onFolderSearchTextChange}
          onKeyDown={onFolderSearchTextKeyDown}
          onFocus={onInputFocus}
          onBlur={onInputBlur}
          value={folderSearchText}
          className={tagFolderInputClass}
          data-test-id="journal-postcreation-tagfolderinput"
        />
      </div>
      <Popover
        isOpen={
          (_.size(_.trim(folderSearchText)) > 0 && !showManageFoldersModal) ||
          tagInputFocus
        }
        containerClassName={classes.popoverContainer}
        containerStyle={{ zIndex: 2500 }}
        positions={["top", "bottom"]}
        align="start"
        reposition={true}
        onClickOutside={() => {
          setFolderSearchText("");
          setTagInputFocus(false);
        }}
        content={({ position, childRect, popoverRect }) => (
          <TagFolderContentV2
            position={position}
            popoverRect={popoverRect}
            childRect={childRect}
            tagsOptions={filteredTagsOptions}
            attachedTags={attachedTags}
            onTagAdd={userType === "staff" ? onTagAddLocal : _.noop}
            onNewTagAdd={userType === "staff" ? onNewTagAddLocal : _.noop}
            setShowManageFoldersModal={setShowManageFoldersModal}
            setCreateFolderOnModalOpen={setCreateFolderOnModalOpen}
            t={t}
            userType={userType}
            closeTagInput={closeTagInput}
          />
        )}
        childrenRef={popoverContainerRef}
        isChildrenRefPassed={true}
        containerParent={popoverParentRef?.current}
      ></Popover>
    </div>
  );
};

const ManageStudentActivity = ({
  activityType,
  screenPanelProps,
  studentSelectionMode = "",
  activityCriteriaSets,
  userType,
  creatorDetails,
  setToastMsg,
  alertVisiblitySettings,
  updateSettings,
  t,
  courseTags,
  defaultStudentNameOrderPreference,
  postPermissionMediaOptions,
  portfolioType,
  enableGlobalHeader,
  disableGlobalHeader,
  updatePostStatusV2,
  updatePostStatus,
  courseId,
  selectedStudentIdsFromFilter,
  studentEdges,
  isGlobalHeaderVisible,
  isCurrentAcademicYearSelected,
  isLoading,
  downloadFromUrl,
  removeProgressElement,
  userId,
}) => {
  const [description, setDescription] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  let attachments = [];
  const oldAttachmentsRef = useRef();
  const [isPostPreviewOn, setIsPostPreviewOn] = useState(false);
  const [studentErrors, setStudentErrors] = useState({});
  const [shouldShowAlert, setShouldShowAlert] = useState(
    !_.get(alertVisiblitySettings, "creationAlert", false)
  );

  const [currentStepDetails, setCurrentStepDetails] = useState({
    currentStep: "",
    showTagModal: false,
  });

  const [overrideModalDetails, setOverrideModalDetails] = useState({});
  const [doNotShowOverrideModal, setDoNotShowOverrideModal] = useState(false);
  const [showSpecificStudentToast, setShowSpecificStudentToast] = useState(
    false
  );
  const [showCommonTabToast, setShowCommonTabToast] = useState(false);
  const [showSchedulePostModal, setShowSchedulePostModal] = useState(false);

  const selectedFolders = getSelectedFoldersMemoized({
    folders: _.get(screenPanelProps, "postDetails.folders", []),
    addedFolders: _.get(screenPanelProps, "postDetails.addedFolders", []),
    removedFolders: _.get(screenPanelProps, "postDetails.removedFolders", []),
  });
  const state = _.get(screenPanelProps, "postDetails.state", "");
  const publishedAt = _.get(screenPanelProps, "postDetails.publishedAt");
  const [scheduledPublishedAt, setScheduledPublishedAt] = useState(
    state === "SCHEDULED" ? publishedAt : null
  );
  const [showAttachmentPreview, setShowAttachmentPreview] = useState(false);
  const [showManageFoldersModal, setShowManageFoldersModal] = useState(false);
  const [createFolderOnModalOpen, setCreateFolderOnModalOpen] = useState(false);
  const isGlobalHeaderVisiblePrevRef = useRef(isGlobalHeaderVisible);
  const selectedStudents = _.get(
    screenPanelProps,
    "postDetails.students.edges",
    []
  );
  const selectedStudentForActivity = _.get(
    screenPanelProps,
    "postDetails.selectedStudentForActivity",
    ACTIVITY_VALUE_STATUS_ALL
  );
  const studentActivityData = _.get(
    screenPanelProps,
    "postDetails.studentActivityData",
    {}
  );

  const attachmentCardStyles = {
    width: _.size(attachments) > 1 ? 438 : 552,
    height: _.size(attachments) > 1 ? 352 : 402,
  };

  const {
    mode,
    onPublishClick,
    onDraftClick,
    onCloseClick,
    updatePost,
    updateFolderArray,
    updateFolderInArrayByName,
    onSendForApprovalClick,
    isUserAllowedToPublishPost,
    isPostCtaDisabled = false,
  } = screenPanelProps;
  const isPostDataValid = () => {
    if (!_.size(selectedStudents) > 0) {
      setToastMsg({ msg: "toastMsgs:please_tag_students", type: "warning" });
      return false;
    }

    let isToastMsgShown = false;
    const updatedStudentErrors = _.cloneDeep(studentErrors);

    _.forEach(selectedStudents, student => {
      const id = _.get(student, "node.id", "");
      _.unset(updatedStudentErrors, [id, "data"]);
      _.unset(updatedStudentErrors, [id, "startTime"]);
      _.unset(updatedStudentErrors, [id, "endTime"]);

      const isDescriptionPresent = !_.isEmpty(
        _.get(studentActivityData, [id, "description", "value"], "")
      );
      const isCriteriaPresent = !_.isEmpty(
        _.get(studentActivityData, [id, "criteria"], {})
      );
      const isAttachmentsPresent = !_.isEmpty(
        _.get(studentActivityData, [id, "attachments"], [])
      );
      const isStartTimePresent = !_.isEmpty(
        _.get(studentActivityData, [id, "startTime", "value"], "")
      );
      const isEndTimePresent = !_.isEmpty(
        _.get(studentActivityData, [id, "endTime", "value"], "")
      );

      // check are startTime and endTime valid
      if (isStartTimePresent && isEndTimePresent) {
        const isAfter = isTimeAfter(
          moment(_.get(studentActivityData, [id, "startTime", "value"])),
          moment(_.get(studentActivityData, [id, "endTime", "value"]))
        );

        if (isAfter)
          _.set(
            updatedStudentErrors,
            [id, "startTime"],
            t("toastMsgs:time_violation_with_label", {
              label: t("common:start"),
              label1: t("common:later"),
              label2: t("common:end"),
              label3: t("common:enter_valid_time"),
            })
          );
      }

      // If any of the student is not filled with any of the activity details, then show toast message
      if (
        !(
          isDescriptionPresent ||
          isCriteriaPresent ||
          isAttachmentsPresent ||
          isStartTimePresent ||
          isEndTimePresent
        )
      ) {
        _.set(
          updatedStudentErrors,
          [id, "data"],
          t("toastMsgs:please_enter_details_for_all_tagged_students")
        );

        if (!isToastMsgShown) {
          setToastMsg({
            msg: "toastMsgs:please_enter_details_for_all_tagged_students",
            type: "warning",
          });
          isToastMsgShown = true;
        }
      }

      const studentError = _.get(updatedStudentErrors, id);
      if (_.isEmpty(studentError)) _.unset(updatedStudentErrors, id);
    });

    setStudentErrors(updatedStudentErrors);

    if (_.isEmpty(updatedStudentErrors)) return true;

    const firstStudentErrorId = _.first(_.keys(updatedStudentErrors));
    const firstStudentError = _.get(
      updatedStudentErrors,
      firstStudentErrorId,
      {}
    );
    const errorFirstKey = _.first(_.keys(firstStudentError));
    const errorFirstValue = _.get(firstStudentError, errorFirstKey, "");

    const status = _.get(studentActivityData, [
      firstStudentErrorId,
      errorFirstKey,
      "status",
    ]);

    if (status === ACTIVITY_VALUE_STATUS_ALL && _.size(selectedStudents) > 1)
      updatePost({ selectedStudentForActivity: ACTIVITY_VALUE_STATUS_ALL });
    else updatePost({ selectedStudentForActivity: firstStudentErrorId });

    setToastMsg({ msg: errorFirstValue, notString: true });
    return false;
  };

  const toggleMaxAttachmentCountAlert = () => {
    setToastMsg({
      msg: t("journal:max_attachment_limit_reached"),
      type: "info",
      customInfoIconStyle: styles.customInfoIconStyle,
      theme: "dark",
      locale_params: [
        {
          isPlainText: true,
          theme: "dark",
          key: "size",
          value: 10,
        },
      ],
    });
  };

  const onPublishClickLocal = e => {
    const isValid = isPostDataValid();
    if (!isValid) return;
    onPublishClick?.(e);
  };

  const onDraftClickLocal = e => {
    const isValid = isPostDataValid();
    if (!isValid) return;
    if (!_.isEmpty(publishedAt)) {
      updatePost({ publishedAt: undefined });
    }
    onDraftClick?.(e);
  };

  const tabs = [];
  const studentIds = [];
  const getPostCreatorName = _.memoize(student => {
    return {
      firstName: _.get(student, "firstName", ""),
      lastName: _.get(student, "lastName", ""),
      middleName: _.get(student, "middleName", ""),
    };
  });
  const avatarClass = classnames({
    [classes.avatar]: isPortfolioParityEnabled(),
  });

  const avatarGroupClass = classnames({
    [classes.avatarGroup]: !isPortfolioParityEnabled(),
    [classes.avatarGroupV2]: isPortfolioParityEnabled(),
  });
  _.forEach(selectedStudents, student => {
    const id = _.get(student, "node.id", "");
    const firstName = _.get(student, "node.firstName", "");
    const lastName = _.get(student, "node.lastName", "");
    const profileImage = _.get(student, "node.profileImage", "");
    studentIds.push(id);

    tabs.push({
      value: id,
      suffix: (
        <Tooltip
          tooltip={getFormattedUserName({
            user: _.get(student, "node"),
          })}
        >
          <span className={classes.tabLabel}>
            {getFormattedUserName({
              user: _.get(student, "node"),
            })}
          </span>
        </Tooltip>
      ),
      customComponent: (
        <ConditionalWrapper
          condition={
            !_.isEmpty(_.get(studentErrors, [id, "data"], "")) ||
            !isStudentDataEqual(
              _.get(studentActivityData, [ACTIVITY_VALUE_STATUS_ALL], {}),
              _.get(studentActivityData, [id], {})
            )
          }
          wrapper={
            <Badge
              type={
                !_.isEmpty(_.get(studentErrors, [id, "data"], ""))
                  ? "warning"
                  : "individuallyRated"
              }
            />
          }
          type={"wrapperAsElement"}
        >
          <div className={avatarClass}>
            <Avatar
              shade={"light"}
              size={"x-large"}
              color={AVATAR_COLORS[hashString(id) % AVATAR_COLORS.length]}
              name={getFormattedUserNameWithoutPronoun({
                user: _.get(student, "node"),
              })}
              src={profileImage}
            />
          </div>
        </ConditionalWrapper>
      ),
    });
  });

  if (_.size(selectedStudents) > 1) {
    const user1 = _.get(selectedStudents, "0", {});
    const user2 = _.get(selectedStudents, "1", {});
    tabs.unshift({
      value: ACTIVITY_VALUE_STATUS_ALL,
      label: `${_.size(selectedStudents)} students`,
      customComponent: (
        <div className={avatarGroupClass}>
          <Avatar
            shade={"light"}
            size={"x-large"}
            color={
              AVATAR_COLORS[
                hashString(_.get(user1, "node.id")) % AVATAR_COLORS.length
              ]
            }
            name={getFormattedUserNameWithoutPronoun({
              user: _.get(user1, "node"),
            })}
            src={_.get(user1, "node.profileImage")}
          />
          <Avatar
            shade={"light"}
            size={"x-large"}
            color={
              AVATAR_COLORS[
                hashString(_.get(user2, "node.id")) % AVATAR_COLORS.length
              ]
            }
            name={getFormattedUserNameWithoutPronoun({
              user: _.get(user2, "node"),
            })}
            src={_.get(user2, "node.profileImage")}
          />
        </div>
      ),
    });
  }

  useEffect(() => {
    if (!_.isEmpty(activityType))
      updatePost({
        studentActivityData: { ...studentActivityData, activityType },
      });
    disableGlobalHeader();
    return () => {
      isGlobalHeaderOnMultipleScreensEnabled() && enableGlobalHeader();
    };
  }, []);

  useEffect(() => {
    if (
      selectedStudentIdsFromFilter &&
      isPortfolioParityEnabled() &&
      isCurrentAcademicYearSelected
    ) {
      updatePost({
        isPrivate: false,
        isHiddenFromStudents: false,
        students: {
          edges: studentEdges,
        },
      });
    }
  }, [studentEdges]);

  useEffect(() => {
    !showAttachmentPreview && disableGlobalHeader();
  }, [showAttachmentPreview]);

  useEffect(() => {
    if (
      (!isGlobalHeaderVisiblePrevRef?.current || isGlobalHeaderVisible) &&
      isGlobalHeaderOnMultipleScreensEnabled()
    ) {
      disableGlobalHeader();
    }
  }, [isGlobalHeaderVisible]);

  useEffect(() => {
    const currentSelectedStudent =
      _.size(tabs) > 0 ? tabs[0].value : ACTIVITY_VALUE_STATUS_ALL;
    updatePost?.({
      selectedStudentForActivity: currentSelectedStudent,
    });
    if (
      currentSelectedStudent == ACTIVITY_VALUE_STATUS_ALL &&
      _.size(selectedStudents) > 1
    ) {
      if (!showCommonTabToast) {
        setToastMsg({
          msg: "toastMsgs:select_common_properties_for_students",
          type: "info",
        });
        setShowCommonTabToast(true);
      }
    }

    if (_.size(selectedStudents) > 0) {
      // remove errors of students that are not selected and add errors of students that are newly selected if errors are present in all state
      const updatedStudentErrors = {};
      const studentErrorsIds = _.keys(studentErrors);
      const commonStudentId = _.intersection(studentIds, studentErrorsIds);
      const newStudentIds = _.difference(studentIds, studentErrorsIds);

      _.forEach(commonStudentId, id => {
        _.set(updatedStudentErrors, id, _.get(studentErrors, id, {}));
      });

      if (!_.isNil(_.get(studentErrors, ACTIVITY_VALUE_STATUS_ALL))) {
        _.forEach(newStudentIds, id => {
          _.set(
            updatedStudentErrors,
            id,
            _.get(studentErrors, ACTIVITY_VALUE_STATUS_ALL)
          );
        });
        if (_.size(selectedStudents) > 1)
          _.set(
            updatedStudentErrors,
            ACTIVITY_VALUE_STATUS_ALL,
            _.get(studentErrors, ACTIVITY_VALUE_STATUS_ALL)
          );
      }

      setStudentErrors(updatedStudentErrors);
    }
  }, [selectedStudents]);

  const [attachmentsMap, setAttachmentsMap] = useState([]);
  const prevAttachmentRef = useRef(attachments);
  useEffect(() => {
    // Set description for selected tab
    const selectedStudentDescription = _.get(
      studentActivityData,
      [selectedStudentForActivity, "description", "value"],
      ""
    );

    if (
      !_.isEmpty(selectedStudentForActivity) &&
      !_.isEmpty(selectedStudentDescription)
    ) {
      setDescription(selectedStudentDescription);
    } else setDescription("");
  }, [selectedStudentForActivity]);

  attachments = _.map(
    _.get(studentActivityData, [selectedStudentForActivity, "attachments"], []),
    attachmentElement => attachmentElement?.value
  );
  const handleSelectedStudentForActivity = value => {
    let activityName = "";
    switch (activityType) {
      case ACTIVITY_NAP:
        activityName = "nap";
        break;
      case ACTIVITY_FOOD:
        activityName = "food";
        break;
      case ACTIVITY_TOILET:
        activityName = "toilet";
        break;
    }
    if (!showSpecificStudentToast) {
      setToastMsg({
        msg:
          value != ACTIVITY_VALUE_STATUS_ALL
            ? "toastMsgs:select_label_details_for_student"
            : "toastMsgs:select_common_properties_for_students",
        type: "info",
        locale_params: [
          { key: "label", value: activityName, isPlainText: true },
        ],
      });
      setShowSpecificStudentToast(true);
    }
    updatePost?.({
      selectedStudentForActivity: value,
    });
  };

  const goToStep = step => {
    if (_.isEmpty(step)) return;
    setCurrentStepDetails({
      currentStep: step,
      showTagModal: true,
    });
  };

  const onCloseTagModal = () => {
    setCurrentStepDetails({
      currentStep: "",
      showTagModal: false,
      currentElementTag: null,
    });
  };

  const onAttachmentAdded = newAttachments => {
    resetSelectStudentDataError("data"); // reset selected student data error if any
    if (_.size(attachments) >= 10 && isPortfolioParityEnabled()) {
      return;
    }

    if (_.size(newAttachments, 0) > 0) {
      let updatedStudentActivities = [];
      if (selectedStudentForActivity === ACTIVITY_VALUE_STATUS_ALL) {
        updatedStudentActivities = updateAllActivityAttachments({
          studentIds,
          currentStudentActivities: studentActivityData,
          key: ["attachments"],
          attachments: newAttachments,
        });
      } else {
        updatedStudentActivities = updateSingleActivityAttachments({
          studentIds,
          studentId: selectedStudentForActivity,
          currentStudentActivities: studentActivityData,
          key: ["attachments"],
          attachments: newAttachments,
        });
        if (_.size(selectedStudents) > 1)
          setToastMsg({
            msg: "toastMsgs:details_updated_with_label",
            locale_params: [
              {
                key: "label",
                value: getActivityName(activityType),
                isPlainText: false,
              },
            ],
            type: "info",
          });
      }
      updatePost({ studentActivityData: updatedStudentActivities });
    }
  };

  const deleteAttachment = (attachmentToRemove, callback) => {
    let updatedStudentActivities = [];
    if (selectedStudentForActivity === ACTIVITY_VALUE_STATUS_ALL) {
      updatedStudentActivities = removeAttachmentFromActivities({
        studentIds:
          selectedStudentForActivity == ACTIVITY_VALUE_STATUS_ALL
            ? studentIds
            : [selectedStudentForActivity],
        currentStudentActivities: studentActivityData,
        key: ["attachments"],
        attachmentToRemove,
      });
      if (_.size(selectedStudents) > 0)
        setShowOverrideModal({
          property: "media",
          operation: "DELETE",
          updatedActivities: updatedStudentActivities,
          affectedStudents:
            selectedStudentForActivity === ACTIVITY_VALUE_STATUS_ALL
              ? _.size(selectedStudents)
              : "selected",
          callbackFn: _.isFunction(callback) ? callback : _.noop,
        });
      else {
        updatePost({ studentActivityData: updatedStudentActivities });
        isPortfolioParityEnabled() &&
          setToastMsg({
            msg: "journal:media_delete_message",
            type: "success",
            locale_params: [
              {
                key: "mediaName",
                value: _.get(attachmentToRemove, "name"),
                isPlainText: true,
              },
            ],
          });
      }
    } else {
      updatedStudentActivities = removeSingleAttachmentFromActivity({
        studentIds: studentIds,
        studentId: selectedStudentForActivity,
        currentStudentActivities: studentActivityData,
        key: ["attachments"],
        attachmentToRemove,
      });

      updatePost({ studentActivityData: updatedStudentActivities });

      if (
        !_.includes(
          _.map(
            _.get(updatedStudentActivities, [
              selectedStudentForActivity,
              "attachments",
            ]),
            obj => obj?.status
          ),
          "INDIVIDUAL"
        ) &&
        _.size(
          _.get(updatedStudentActivities, [
            selectedStudentForActivity,
            "attachments",
          ])
        ) ==
          _.size(
            _.get(updatedStudentActivities, [
              ACTIVITY_VALUE_STATUS_ALL,
              "attachments",
            ])
          )
      )
        return;

      if (_.size(selectedStudents) > 1)
        setToastMsg({
          msg: "toastMsgs:details_updated_with_label",
          locale_params: [
            {
              key: "label",
              value: getActivityName(activityType),
              isPlainText: false,
            },
          ],
          type: "info",
        });

      _.isFunction(callback) && callback();
    }
  };

  const resetSelectStudentDataError = key => {
    const updatedStudentErrors = _.cloneDeep(studentErrors);

    if (selectedStudentForActivity == ACTIVITY_VALUE_STATUS_ALL) {
      _.forEach(studentIds, id => {
        _.unset(updatedStudentErrors, [id, key]);
        const studentError = _.get(updatedStudentErrors, id);
        if (_.isEmpty(studentError)) _.unset(updatedStudentErrors, id);
      });
    } else {
      _.unset(updatedStudentErrors, [selectedStudentForActivity, key]);
      const studentError = _.get(
        updatedStudentErrors,
        selectedStudentForActivity
      );
      if (_.isEmpty(studentError))
        _.unset(updatedStudentErrors, selectedStudentForActivity);
    }

    setStudentErrors(updatedStudentErrors);
  };

  const saveDataToRedux = (key, value) => {
    if (!(key === "startTime" || key === "endTime"))
      resetSelectStudentDataError("data"); // reset error if any for selected student if key is not startTime or endTime

    let updatedStudentActivities = {};
    let shouldShowOverrideModal = false;
    if (selectedStudentForActivity == ACTIVITY_VALUE_STATUS_ALL) {
      const result = updateAllActivities({
        studentIds,
        currentStudentActivities: studentActivityData,
        key: [key],
        value: { value },
      });
      shouldShowOverrideModal = _.get(result, "shouldShowOverrideModal", false);
      updatedStudentActivities = _.get(result, "updatedStudentActivities", {});
    } else {
      updatedStudentActivities = updateSingleActivity({
        studentIds,
        studentId: selectedStudentForActivity,
        currentStudentActivities: studentActivityData,
        key: [key],
        value: { value },
      });
      if (
        _.get(updatedStudentActivities, [
          selectedStudentForActivity,
          key,
          "status",
        ]) != ACTIVITY_VALUE_STATUS_ALL &&
        _.size(selectedStudents) > 1
      )
        setToastMsg({
          msg: "toastMsgs:details_updated_with_label",
          locale_params: [
            {
              key: "label",
              value: getActivityName(activityType),
              isPlainText: false,
            },
          ],
          type: "info",
        });
    }
    if (shouldShowOverrideModal)
      setShowOverrideModal({
        operation: "UPDATE",
        property: key,
        updatedActivities: updatedStudentActivities,
      });
    else updatePost({ studentActivityData: updatedStudentActivities });
  };

  const getSharedWithDetails = t => {
    const isHiddenFromStudents = _.get(
      screenPanelProps,
      "postDetails.isHiddenFromStudents",
      true
    );
    const isPrivate = _.get(screenPanelProps, "postDetails.isPrivate", true);

    if (isHiddenFromStudents && isPrivate)
      return {
        icon: <LockOutlined />,
        text: t("journal:private"),
        alertText: null,
        alertKey: null,
      };
    else if (isHiddenFromStudents && !isPrivate)
      return {
        icon: <FamilyOutlined />,
        text: t("journal:only_families"),
        alertText: t("journal:activity_post_preview_alert_families"),
        alertKey: "families",
      };
    else if (!isHiddenFromStudents && isPrivate)
      return {
        icon: <StudentOutlined />,
        text: _.capitalize(t("journal:shared_with_sidebar_only_students")),
        alertText: t("journal:activity_post_preview_alert_students"),
        alertKey: "students",
      };
    else
      return {
        icon: <GlobeOutlined />,
        text: t("journal:students_n_families"),
        alertText: t("journal:activity_post_preview_alert_public"),
        alertKey: "public",
      };
  };

  const TagStudentButton = ({ studentSelectionMode, t }) => {
    const handleKeyDown = e => {
      onEnterOrSpaceKeyDown(e, () => {
        goToStep(
          studentSelectionMode === "SINGLE"
            ? "TAG_SINGLE_STUDENT"
            : "TAG_STUDENT"
        );
      });
    };
    return (
      <div
        onClick={() =>
          goToStep(
            studentSelectionMode === "SINGLE"
              ? "TAG_SINGLE_STUDENT"
              : "TAG_STUDENT"
          )
        }
        className={classes.tagStudentButtonContainer}
        data-test-id="journal-postcreation-tagstudent-button"
        tabIndex={0}
        onKeyDown={handleKeyDown}
      >
        <span
          className={classes.tagStudentButton}
          style={
            isPortfolioParityEnabled() ? styles.tagStudentButton : BLANK_OBJECT
          }
        >
          {_.isEmpty(selectedStudents) ? (
            <StudentAddOutlined size={"x-small"} />
          ) : (
            <PencilLineOutlined size={"x-small"} />
          )}
        </span>
        <span className={classes.containerText}>
          {_.isEmpty(selectedStudents)
            ? studentSelectionMode === "SINGLE"
              ? t("journal:tag_student")
              : t("journal:tag_students")
            : t("common:edit")}
        </span>
      </div>
    );
  };

  const sharedWithDetails = getSharedWithDetails(t);

  const setShowOverrideModal = ({
    operation,
    property,
    updatedActivities,
    affectedStudents = _.size(selectedStudents),
    callbackFn = _.noop,
  }) => {
    if (doNotShowOverrideModal) {
      updatePost({ studentActivityData: updatedActivities });
      return;
    }
    const { localeString, notifyLocale } = getLocaleForOverrideModal({
      operation,
      property,
      studentsCount: affectedStudents,
      t,
    });
    setOverrideModalDetails({
      localeString,
      notifyLocale,
      data: updatedActivities,
      operation,
      property,
      showModal: true,
      callbackFn,
    });
  };

  const onConfirmOverride = ({ updatedActivities, locale, property }) => {
    updatePost?.({
      studentActivityData: updatedActivities,
    });
    setOverrideModalDetails({ showModal: false });
    setToastMsg({
      msg: locale,
      type: "info",
      locale_params: [
        {
          key: "students",
          value:
            _.size(selectedStudents) > 0 ? _.size(selectedStudents) : "all",
          isPlainText: true,
        },
        { key: "property", value: property, isPlainText: true },
      ],
    });
  };

  const selectedStudentNapStartTime =
    activityType === ACTIVITY_NAP &&
    !_.isNil(
      _.get(studentActivityData, [
        selectedStudentForActivity,
        "startTime",
        "value",
      ])
    )
      ? moment(
          _.get(studentActivityData, [
            selectedStudentForActivity,
            "startTime",
            "value",
          ])
        )
      : null;

  const selectedStudentNapEndTime =
    activityType === ACTIVITY_NAP &&
    !_.isNil(
      _.get(studentActivityData, [
        selectedStudentForActivity,
        "endTime",
        "value",
      ])
    )
      ? moment(
          _.get(studentActivityData, [
            selectedStudentForActivity,
            "endTime",
            "value",
          ])
        )
      : null;

  const handleNapTimeChange = (key, value) => {
    const updatedStudentErrors = _.cloneDeep(studentErrors);

    if (selectedStudentForActivity == ACTIVITY_VALUE_STATUS_ALL) {
      _.forEach(studentIds, id => {
        _.unset(updatedStudentErrors, [id, "startTime"]);
        _.unset(updatedStudentErrors, [id, "endTime"]);
        const studentError = _.get(updatedStudentErrors, id);
        if (_.isEmpty(studentError)) _.unset(updatedStudentErrors, id);
      });
    }
    _.unset(updatedStudentErrors, [selectedStudentForActivity, "startTime"]);
    _.unset(updatedStudentErrors, [selectedStudentForActivity, "endTime"]);

    if (
      key === "startTime" &&
      !_.isNil(value) &&
      !_.isNil(selectedStudentNapEndTime) &&
      !isTimeAfter(selectedStudentNapEndTime, value)
    ) {
      if (selectedStudentForActivity === ACTIVITY_VALUE_STATUS_ALL)
        _.forEach(studentIds, id => {
          _.set(
            updatedStudentErrors,
            [id, key],
            t("toastMsgs:time_violation_with_label", {
              label: t("common:start"),
              label1: t("common:later"),
              label2: t("common:end"),
              label3: t("common:enter_valid_time"),
            })
          );
        });

      _.set(
        updatedStudentErrors,
        [selectedStudentForActivity, key],
        t("toastMsgs:time_violation_with_label", {
          label: t("common:start"),
          label1: t("common:later"),
          label2: t("common:end"),
          label3: t("common:enter_valid_time"),
        })
      );
    }

    if (
      key === "endTime" &&
      !_.isNil(value) &&
      !_.isNil(selectedStudentNapStartTime) &&
      !isTimeAfter(value, selectedStudentNapStartTime)
    ) {
      if (selectedStudentForActivity === ACTIVITY_VALUE_STATUS_ALL)
        _.forEach(studentIds, id => {
          _.set(
            updatedStudentErrors,
            [id, key],
            t("toastMsgs:time_violation_with_label", {
              label: t("common:end"),
              label1: t("common:later"),
              label2: t("common:start"),
              label3: t("common:enter_valid_time"),
            })
          );
        });

      _.set(
        updatedStudentErrors,
        [selectedStudentForActivity, key],
        t("toastMsgs:time_violation_with_label", {
          label: t("common:end"),
          label1: t("common:later"),
          label2: t("common:start"),
          label3: t("common:enter_valid_time"),
        })
      );
    }

    const studentError = _.get(
      updatedStudentErrors,
      selectedStudentForActivity
    );

    if (_.isEmpty(studentError))
      _.unset(updatedStudentErrors, selectedStudentForActivity);

    if (_.size(selectedStudents) > 0 && _.size(updatedStudentErrors) === 1) {
      const id = _.keys(updatedStudentErrors)[0];
      if (id === ACTIVITY_VALUE_STATUS_ALL)
        _.unset(updatedStudentErrors, id, key);
      if (_.size(_.get(updatedStudentErrors, id)) === 0)
        _.unset(updatedStudentErrors, id);
    }

    setStudentErrors(updatedStudentErrors);

    saveDataToRedux(
      key,
      !_.isNil(value) && value.isValid() ? value.toISOString() : null
    );
  };

  const handleAlertClose = (value, setState) => {
    updateSettings({
      id: creatorDetails.id,
      type: "user",
      settings: [
        {
          name: "TeacherPortal:ClosedActivityTrackingInfoModal",
          value: JSON.stringify(value),
        },
      ],
      showToastMsg: false,
    });
    setState(false);
  };

  const onSchedulePostDateChange = dateTimeObject => {
    const newPublishedAt = getCombinedDateAndTimeMoment(
      dateTimeObject
    ).toISOString();
    setScheduledPublishedAt(newPublishedAt);
    updatePost({ publishedAt: newPublishedAt });
    setShowSchedulePostModal(false);
  };

  const onManageFolderModalClose = () => {
    setShowManageFoldersModal(false);
  };
  const attachedTags = _.get(screenPanelProps, "postDetails.folders", []);
  const addedTags = _.get(screenPanelProps, "postDetails.addedFolders", []);
  const removedTags = _.get(screenPanelProps, "postDetails.removedFolders", []);
  const updatedTags = useMemo(() => {
    let updatedTagsArray = [];
    if (!_.isNil(attachedTags) && !_.isNil(addedTags)) {
      updatedTagsArray = [...attachedTags, ...addedTags];
      if (!_.isNil(removedTags) && _.size(removedTags, 0) > 0) {
        updatedTagsArray = _.filter(updatedTagsArray, tag =>
          _.isUndefined(
            _.find(removedTags, removedTag => removedTag?.id == tag?.id)
          )
        );
      }
    }
    return updatedTagsArray;
  }, [attachedTags, addedTags, removedTags]);

  const unionCourseUpdateTags = useMemo(() => {
    return _.unionBy(courseTags, updatedTags, tag => tag?.name);
  }, [courseTags, updatedTags]);

  const isAttachmentAdded = () => {
    const [attachmentsWithId, attachmentsWithoutId] = _.partition(
      attachments,
      "id"
    );
    return _.size(attachmentsWithoutId) > 0;
  };

  const getPermissableMediaOptions = mediaStateOptions => {
    const mediaOptions = [];
    if (_.isEqual(portfolioType, "senior")) {
      return _.map(mediaStateOptions, media => {
        const { perm, ...updatedMediaObject } = media;
        return updatedMediaObject;
      });
    }
    _.forEach(mediaStateOptions, media => {
      const { perm, ...updatedMedia } = media;
      if (perm && !_.isEqual(perm, "MEDIA")) {
        if (_.includes(postPermissionMediaOptions, perm)) {
          mediaOptions.push(updatedMedia);
        }
      } else if (
        _.isEqual(perm, "MEDIA") &&
        (_.includes(postPermissionMediaOptions, "PHOTO") ||
          _.includes(postPermissionMediaOptions, "VIDEO"))
      ) {
        mediaOptions.push(updatedMedia);
      }
    });
    return mediaOptions;
  };

  const [currentDialogAction, setCurrentDialogAction] = useState("");
  const [currentDialogPostId, setCurrentDialogPostId] = useState("");
  const [
    currentDialogPostCreatorName,
    setCurrentDialogPostCreatorName,
  ] = useState("");
  const [showEditAttachmentModal, setEditAttachmentModal] = useState(false);
  const [currentAttachmentIndex, setCurrentAttachmentIndex] = useState(0);
  const [showMediaModal, setShowMediaModal] = useState(false);

  const onDialogActionClick = ({ id, action, createdByName }) => {
    setCurrentDialogAction(action);
    setCurrentDialogPostId(id);
    setCurrentDialogPostCreatorName(createdByName);
  };

  const OnToggleDialogueClick = () => {
    setCurrentDialogAction("");
    setCurrentDialogPostId("");
    setCurrentDialogPostCreatorName("");
  };

  const headerStyles = {
    padding: "24px 24px 0px 32px",
    ..._.get(DIALOGS_INFO[currentDialogAction], "headerStyles", {}),
  };

  const showPromptDetail =
    currentDialogAction == "REJECT_POST" ||
    currentDialogAction == "APPROVE_WITH_COMMENT";

  const onDialogConfirmClick = comment => {
    const commentText = _.trim(comment);
    const updatePostFields = isPortfolioReviewSetupEnabled()
      ? [true, undefined, false, true]
      : [];
    switch (currentDialogAction) {
      case "APPROVE_WITH_COMMENT":
        updatePostStatusV2("PUBLISHED", {
          approveComment: commentText,
        });
        onCloseClick();
        break;
      case "REJECT_POST":
        updatePostStatusV2("REJECTED", {
          rejectComment: commentText,
        });
        onCloseClick();
        break;
      case "IN_APPROVAL":
        updatePostStatus(currentDialogPostId, currentDialogAction);
        onCloseClick();
        break;
    }
  };
  const fetchAudioAttachment = () => {
    return _.filter(attachments, { type: "AUDIO" });
  };
  const getDropDownOptionsWithState = () => {
    if (_.size(attachments) >= 10) {
      return getPermissableMediaOptions(DROP_DOWN_OPTIONS_V2_DISABLED);
    } else if (_.size(fetchAudioAttachment()) === 1) {
      return getPermissableMediaOptions(DROP_DOWN_OPTIONS_AUDIO_DISABLED);
    }
    return getPermissableMediaOptions(DROP_DOWN_OPTIONS_V2);
  };

  const isGlobalHeaderEnabled = isGlobalHeaderOnMultipleScreensEnabled();

  const onMultipleAttachmentsAdded = async newAttachments => {
    if (_.size(newAttachments) > 10) {
      toggleMaxAttachmentCountAlert();
    } else {
      if (_.size(newAttachments) && _.size(attachments) === 10) {
        toggleMaxAttachmentCountAlert();
      }
    }
  };

  const onEditAttachmentModalClose = () => {
    setEditAttachmentModal(false);
  };

  const onEditAttachmentModalDoneClick = () => {};

  const renderAttachment = ({
    toggleMediaModalWithIndex,
    setEditAttachmentModal,
    studentActivityData,
    studentIds,
    selectedStudentForActivity,
    mode,
  }) => {
    const toggleEditAttachmentModal = () => {
      setEditAttachmentModal(!showEditAttachmentModal);
    };

    const updateAttachments = _.map(attachments, item => {
      return { ...item, id: _.get(item, "id", generateRandomId()) };
    });

    const renderAttachmentStyle = {
      overFlow: _.size(attachments) === 2 ? "hidden" : "scroll",
      zIndex: "auto",
    };
    return (
      <div className={classes.renderAttachment} style={renderAttachmentStyle}>
        <ReorderAttachment
          attachments={updateAttachments}
          studentActivityData={studentActivityData}
          studentIds={studentIds}
          selectedStudentForActivity={selectedStudentForActivity}
          setAttachments={_.noop}
          toggleMediaModalWithIndex={toggleMediaModalWithIndex}
          toggleEditAttachmentModal={toggleEditAttachmentModal}
          updatePost={updatePost}
          reorderTooltip={t("journal:reorder_tooltip")}
          setToastMsg={setToastMsg}
          isLoading={isLoading}
          deleteAttachment={deleteAttachment}
          isActivityTrackingPost={true}
        />
      </div>
    );
  };

  const prevAttachmentCount = useRef(_.size(attachments));

  const toggleMediaModalWithIndex = ({ value, attachmentIndex = 0 }) => {
    setShowMediaModal(value);
    setCurrentAttachmentIndex(attachmentIndex);
  };

  const toggleMediaModal = value => {
    setShowMediaModal(value);
    setCurrentAttachmentIndex(0);
  };

  const nonAudioAttachments = getNonAudioAttachments(attachments);

  const getEditModalAttachments = attachments => {
    const updateAttachments =
      mode === "edit"
        ? attachments
        : _.map(attachments, item => {
            return { ...item, id: _.get(item, "id", generateRandomId()) };
          });
  };

  const audioFileDownload = attachment => {
    let name = _.get(attachment, "name", "");
    if (_.isEmpty(name)) {
      name = "toddle_audio_" + moment().format("DD-MM-YY_h_mm");
    }

    const id = "Toddle_audio_#123";

    downloadFromUrl({
      name: name,
      attachment: attachment,
      shouldAskForSave: true,
      fileUploadId: id,
    }).then(() => {
      removeProgressElement({ id });
    });
  };

  const updateAttachmentIndex = activeIndex => {
    let updatedAttachments = [...attachments];
    _.pullAt(updatedAttachments, activeIndex);
    updatedAttachments = _.filter(
      updatedAttachments,
      attachment => attachment?.type !== "AUDIO"
    );

    if (activeIndex + 1 === _.size(updatedAttachments)) {
      if (activeIndex === 0) {
        setCurrentAttachmentIndex(activeIndex);
      } else setCurrentAttachmentIndex(activeIndex - 1);
    } else if (activeIndex + 1 <= _.size(updatedAttachments)) {
      setCurrentAttachmentIndex(activeIndex + 1);
    } else if (
      activeIndex === _.size(updatedAttachments) &&
      _.size(updatedAttachments)
    ) {
      setCurrentAttachmentIndex(activeIndex - 1);
    }
    if (!_.size(updatedAttachments)) {
      toggleMediaModal(false);
    }
  };
  const onDeleteMedia = activeIndex => {
    const attachmentToDelete = _.nth(attachments, activeIndex);
    deleteAttachment(attachmentToDelete, () => {
      updateAttachmentIndex(activeIndex);
    });
  };

  const theatreModeAttachments = {
    attachments: nonAudioAttachments,
  };

  const hideMediaModal = () => {
    toggleMediaModal(false);
  };

  const handleDeleteAttachment = attachment => () => {
    deleteAttachment(attachment);
  };

  const handleDownloadAttachment = attachment => () => {
    audioFileDownload(attachment);
  };

  const updateCurrentActiveIndex = activeIndex => {
    setCurrentAttachmentIndex(activeIndex);
  };

  const handleKeyDownShareWith = e => {
    onEnterOrSpaceKeyDown(e, () => {
      goToStep("SHARE_WITH");
    });
  };

  return (
    <>
      {showSchedulePostModal ? (
        <SchedulePostModal
          onClosePostScheduleModal={() => setShowSchedulePostModal(false)}
          editDateDetails={
            state === "SCHEDULED" || !_.isEmpty(scheduledPublishedAt)
              ? {
                  date: moment(scheduledPublishedAt),
                  time: moment(scheduledPublishedAt),
                }
              : null
          }
          onConfirmDateChange={onSchedulePostDateChange}
          canBackdate={_.includes(
            [
              "PUBLISHED",
              "DRAFT",
              ...(isPortfolioReviewSetupEnabledAndIsReviewRoute()
                ? ["IN_APPROVAL"]
                : []),
            ],
            state
          )}
        />
      ) : null}
      {isPostPreviewOn ? (
        <PostPreview
          setIsPostPreviewOn={setIsPostPreviewOn}
          activityCriteriaSets={activityCriteriaSets}
          studentActivityData={studentActivityData}
          selectedStudents={selectedStudents}
          selectedFolders={selectedFolders}
          creatorDetails={creatorDetails}
          sharedWithDetails={sharedWithDetails}
          publishedAt={scheduledPublishedAt}
          alertVisiblitySettings={alertVisiblitySettings}
          handleAlertClose={handleAlertClose}
        />
      ) : null}
      {overrideModalDetails.showModal ? (
        <OverrideModal
          setOverrideModalDetails={setOverrideModalDetails}
          overrideModalDetails={overrideModalDetails}
          onConfirmOverride={onConfirmOverride}
          setDoNotShowOverrideModal={setDoNotShowOverrideModal}
          doNotShowOverrideModal={doNotShowOverrideModal}
          studentActivityData={studentActivityData}
          setDescription={setDescription}
          t={t}
        />
      ) : null}
      <ScreenPanel
        {...screenPanelProps}
        containerStyle={styles.containerStyle}
        rightContainerContent={
          <Button
            onClick={() => setIsPostPreviewOn(true)}
            icon={<EyeOutlined />}
            variant={"plain"}
            disabled={
              _.isEmpty(selectedStudents) ||
              _.isEmpty(_.omit(studentActivityData, "activityType")) ||
              isUploading
            }
          >
            {_.capitalize(
              t("common:label_preview", {
                label: t("common:post"),
              })
            )}
          </Button>
        }
        footerContainerStyle={styles.footerContainerStyle}
        showFooter={!isPortfolioParityEnabled()}
        footerComponent={
          <FooterComponent
            t={t}
            onPublishClick={onPublishClickLocal}
            onDraftClick={onDraftClickLocal}
            state={state}
            mode={mode}
            onCloseClick={onCloseClick}
            disabled={
              (_.isEmpty(selectedStudents) &&
                _.isEmpty(_.omit(studentActivityData, "activityType"))) ||
              isUploading
            }
            publishedAt={publishedAt}
            scheduledPublishedAt={scheduledPublishedAt}
            setScheduledPublishedAt={setScheduledPublishedAt}
            togglePostScheduleModal={value => setShowSchedulePostModal(value)}
            updatePost={updatePost}
            setToastMsg={setToastMsg}
          />
        }
        showNewHeaderDesign={isPortfolioParityEnabled()}
        headerRightComponent={
          <HeaderRightComponent
            t={t}
            onPublishClick={onPublishClickLocal}
            onDraftClick={onDraftClickLocal}
            state={state}
            mode={mode}
            onCloseClick={onCloseClick}
            disabled={
              (_.isEmpty(selectedStudents) &&
                _.isEmpty(_.omit(studentActivityData, "activityType"))) ||
              isUploading
            }
            publishedAt={publishedAt}
            scheduledPublishedAt={scheduledPublishedAt}
            setScheduledPublishedAt={setScheduledPublishedAt}
            togglePostScheduleModal={value => setShowSchedulePostModal(value)}
            updatePost={updatePost}
            setToastMsg={setToastMsg}
            selectedStudents={selectedStudents}
            studentActivityData={studentActivityData}
            isUploading={isUploading}
            onSendForApprovalClick={onSendForApprovalClick}
            setIsPostPreviewOn={setIsPostPreviewOn}
            userType={userType}
            isUserAllowedToPublishPost={isUserAllowedToPublishPost}
            isPostCtaDisabled={isPostCtaDisabled}
            updatePostStatusV2={updatePostStatusV2}
            OnToggleDialogueClick={OnToggleDialogueClick}
            onDialogActionClick={onDialogActionClick}
            postDetails={screenPanelProps?.postDetails}
            isGlobalHeaderEnabled={isGlobalHeaderEnabled}
            userId={userId}
          />
        }
      >
        {currentStepDetails.showTagModal ? (
          <CreatePost
            currentStep={currentStepDetails.currentStep}
            isInnerModal={true}
            onClose={onCloseTagModal}
            showNewDesign={true}
            mode={_.get(screenPanelProps, "mode", "create")}
            showNewDesignV2={isPortfolioParityEnabled()}
          />
        ) : null}
        <div className={classes.mainContainer}>
          <section
            className={classes.container}
            style={{ paddingBottom: isPortfolioParityEnabled() ? "0px" : "" }}
          >
            {studentSelectionMode !== "SINGLE" ? (
              <ScrollableCarousel
                scrollAmount={98 * 5}
                leftButtonStyle={{ transform: "translateY(-80%)" }}
                rightButtonStyle={{ transform: "translateY(-80%)" }}
              >
                <div className={classes.tagListContainer}>
                  <TagStudentButton
                    studentSelectionMode={studentSelectionMode}
                    t={t}
                  />
                  <Tabs
                    options={tabs}
                    dsVersion="2.0"
                    value={selectedStudentForActivity}
                    onChange={handleSelectedStudentForActivity}
                    containerStyle={{ height: "36px", width: "84px" }}
                    testId="journal-postcreation-student-tabs"
                  />
                </div>
              </ScrollableCarousel>
            ) : (
              <div className={classes.singleTagListContainer}>
                {!_.isEmpty(selectedStudents) ? (
                  <div className={classes.profileContainer}>
                    <Avatar
                      shade={"light"}
                      size={"x-large"}
                      color={"pink"}
                      name={getFormattedUserName({
                        user: _.get(selectedStudents[0], "node"),
                      })}
                      src={_.get(selectedStudents[0], "node.profileImage", "")}
                    />
                    <span className={classes.profileText}>
                      {getFormattedUserName({
                        user: _.get(selectedStudents[0], "node"),
                      })}
                    </span>
                  </div>
                ) : null}
                {_.isEmpty(selectedStudents) ? (
                  <TagStudentButton
                    studentSelectionMode={studentSelectionMode}
                    t={t}
                  />
                ) : (
                  <IconButton
                    variant={"plain"}
                    size={"large"}
                    onClick={() => goToStep("TAG_SINGLE_STUDENT")}
                    icon={<PencilLineOutlined />}
                  />
                )}
              </div>
            )}
            {_.size(selectedStudents) > 1 &&
            selectedStudentForActivity === ACTIVITY_VALUE_STATUS_ALL &&
            shouldShowAlert ? (
              <div className={classes.alertContainer}>
                <Alert
                  type="info"
                  message={t("journal:activity_creation_screen_all_tab_alert")}
                  isClosable={true}
                  onClose={() =>
                    handleAlertClose(
                      {
                        ...alertVisiblitySettings,
                        creationAlert: true,
                      },
                      setShouldShowAlert
                    )
                  }
                />
              </div>
            ) : null}
            {activityType === ACTIVITY_NAP ? (
              <div className={classes.timeContainer}>
                <TimePicker
                  label={t("journal:record_nap_label_time", {
                    label: t("common:start"),
                  })}
                  placeholder={"HH:MM"}
                  size={"large"}
                  isClearable={true}
                  value={selectedStudentNapStartTime}
                  onChange={value => handleNapTimeChange("startTime", value)}
                  timeError={
                    !_.isNil(
                      _.get(studentErrors, [
                        selectedStudentForActivity,
                        "startTime",
                      ])
                    )
                      ? _.get(studentErrors, [
                          selectedStudentForActivity,
                          "startTime",
                        ])
                      : ""
                  }
                  testId="journal-postcreation-nap-starttime"
                />
                <TimePicker
                  label={t("journal:record_nap_label_time", {
                    label: t("common:end"),
                  })}
                  placeholder={"HH:MM"}
                  size={"large"}
                  isClearable={true}
                  value={selectedStudentNapEndTime}
                  onChange={value => handleNapTimeChange("endTime", value)}
                  timeError={
                    !_.isNil(
                      _.get(studentErrors, [
                        selectedStudentForActivity,
                        "endTime",
                      ])
                    )
                      ? _.get(studentErrors, [
                          selectedStudentForActivity,
                          "endTime",
                        ])
                      : ""
                  }
                  testId="journal-postcreation-nap-endtime"
                />
              </div>
            ) : null}
            {updatePost ? (
              <ActivitySelector
                activityCriteriaSets={activityCriteriaSets}
                selectedStudentForActivity={selectedStudentForActivity}
                studentActivityData={studentActivityData}
                updatePost={updatePost}
                studentIds={studentIds}
                setShowOverrideModal={setShowOverrideModal}
                setToastMsg={setToastMsg}
                activityName={getActivityName(activityType)}
                resetSelectStudentDataError={resetSelectStudentDataError}
              />
            ) : null}
            <div
              className={classes.descriptionContainer}
              style={!_.isEmpty(attachments) ? { marginBottom: "-6px" } : {}}
            >
              <TextAreaInput
                placeholder={t("journal:type_to_add_description")}
                minRows={_.isEmpty(attachments) ? 4 : 1}
                value={description}
                onChange={e => setDescription(e.target.value)}
                onBlur={() => saveDataToRedux("description", description)}
                className={classes.description}
                testId="journal-postcreation-description"
              />
            </div>
            {isPortfolioParityEnabled()
              ? _.map(fetchAudioAttachment(), (attachment, index) => (
                  <div
                    className={classes.audioCard}
                    style={styles.audioCardStyle}
                  >
                    <AudioWaveformPlayer
                      attachment={attachment}
                      audioLoaded={_.noop}
                    />
                    <span style={styles.audioActionButtonStyle}>
                      <IconButton
                        icon={<DeleteOutlined />}
                        variant="plain"
                        size="small"
                        onClick={handleDeleteAttachment(attachment)}
                      />
                      <IconButton
                        icon={<DownloadOutlined />}
                        variant="plain"
                        size="small"
                        onClick={handleDownloadAttachment(attachment)}
                      />
                    </span>
                  </div>
                ))
              : null}
            <div className={classes.attachmentsContainer}>
              {_.size(nonAudioAttachments) === 1 ? (
                <div>
                  <MultipleAttachmentsSlider
                    attachments={nonAudioAttachments}
                    mode={"edit"}
                    showDeleteIcon={true}
                    deleteAttachment={deleteAttachment}
                    slidesToShow={1}
                    slidesToScroll={1}
                    shouldClickOnMedia={true}
                    showAttachmentAsMediaCard={false}
                    showAttachmentsUsingScrollableCarousel={true}
                    attachmentCardStyle={{
                      width: _.size(nonAudioAttachments) > 1 ? 438 : 552,
                      height: _.size(nonAudioAttachments) > 1 ? 352 : 402,
                    }}
                    attachmentBorderRadius={"16px"}
                    listContainerClass={classes.attachmentCarouselContainer}
                    attachmentItemCustomClass={
                      _.size(nonAudioAttachments) > 1
                        ? classes.attachmentItemSmallWidth
                        : classes.attachmentItemFullWidth
                    }
                    showDots={true}
                    deleteButtonVariant={"small"}
                    extensionTagSize={"small"}
                    showTheatreViewByParent={showAttachmentPreview}
                    setShowTheatreViewInParent={setShowAttachmentPreview}
                    showControlDots={!isPortfolioParityEnabled()}
                    showActiveControlDotValue={
                      isPortfolioParityEnabled() && isAttachmentAdded()
                    }
                  />
                </div>
              ) : _.size(attachments) > 1 ? (
                <div>
                  <ConditionalWrapper
                    condition={_.size(attachments) > 2}
                    wrapper={
                      <ScrollableCarousel
                        scrollAmount={280} // card width + padding
                        showActiveControlDot={
                          prevAttachmentCount.current !== _.size(attachments) &&
                          prevAttachmentCount.current <= 10
                        }
                        activeControlDotValue={_.size(attachments)}
                      />
                    }
                    type={"wrapperAsElement"}
                  >
                    {renderAttachment({
                      toggleMediaModalWithIndex,
                      setEditAttachmentModal,
                      studentActivityData,
                      studentIds,
                      selectedStudentForActivity,
                      mode,
                    })}
                  </ConditionalWrapper>
                </div>
              ) : null}
              <div
                className={classes.filePickerContainer}
                style={{ marginTop: _.size(attachments) > 0 ? "32px" : "0" }}
              >
                <CreateDropDown
                  dropDownOptions={
                    isPortfolioParityEnabled()
                      ? getDropDownOptionsWithState()
                      : DROP_DOWN_OPTIONS
                  }
                  parentType={"POST"}
                  multiple={true}
                  addAttachment={onAttachmentAdded}
                  onMultipleFilesUploaded={
                    isPortfolioParityEnabled()
                      ? onMultipleAttachmentsAdded
                      : _.noop
                  }
                  updateLoadingState={setIsUploading}
                  customDropZoneStyle={{ width: "fit-content" }}
                  isShowIconsInBar={true}
                  showV2Icons={true}
                  iconButtonVariant={
                    isPortfolioParityEnabled() ? "plain" : "outlined-subtle"
                  }
                  iconButtonVariantV2={"neutral"}
                  iconButtonType={"plain"}
                  showCaptureVoiceIcon={isPortfolioParityEnabled()}
                  reduceSpacingBetweenIcons={isPortfolioParityEnabled()}
                  showPlaceholderFileIcon={isPortfolioParityEnabled()}
                  iconButtonSize={
                    isPortfolioParityEnabled() ? "medium" : "large"
                  }
                  testId="journal-postcreation-attachmentdropdown"
                  disableAllOptions={_.size(attachments) >= 10}
                  isAudioDisabled={
                    isPortfolioParityEnabled() &&
                    _.size(fetchAudioAttachment()) === 1
                  }
                  showNewDesignForCaptureOptions={isPortfolioParityEnabled()}
                />
              </div>
            </div>
            {isPortfolioParityEnabled() ? (
              <div className={classes.tagsInputContainerV2}>
                {/*Add Custom tags Card */}
                <CustomTagsCard
                  tags={unionCourseUpdateTags}
                  updateFolderArray={updateFolderArray}
                  updateFolderInArrayByName={updateFolderInArrayByName}
                  attachedTags={updatedTags}
                  t={t}
                  showManageFoldersModal={showManageFoldersModal}
                  setShowManageFoldersModal={setShowManageFoldersModal}
                  setCreateFolderOnModalOpen={setCreateFolderOnModalOpen}
                  userType={userType}
                />
              </div>
            ) : null}
          </section>
          {!isPortfolioParityEnabled() ? (
            <TagCard
              icon={<FolderOutlined size={"x-small"} />}
              title={t("journal:tag_folders")}
              data={selectedFolders}
              showInAccordian={true}
              expandedContent={
                <TaggedFolders
                  folders={selectedFolders}
                  showFolderIcon={true}
                  tagSize={"small"}
                  containerStyle={{
                    paddingLeft: "24px",
                    marginTop: "16px",
                    gap: "8px",
                    maxWidth: "500px",
                    cursor: "default",
                  }}
                  singleTagTextStyle={{
                    fontSize: "1.6rem",
                    colors: colors.textDefault,
                  }}
                />
              }
              subText={
                !_.isEmpty(selectedFolders) ? (
                  <span className={classes.folderBadge}>
                    {selectedFolders.length}
                  </span>
                ) : null
              }
              handleClick={() => goToStep("TAG_FOLDERS")}
            />
          ) : null}
          <TagCard
            icon={<TeacherShareOutlined size={"x-small"} />}
            title={t("common:share_with")}
            data={"Private"}
            subText={
              isPortfolioParityEnabled() ? (
                <div
                  tabIndex={0}
                  onKeyDown={handleKeyDownShareWith}
                  className={classes.sharedWithContainer}
                >
                  <Tag size="x-small">
                    <div
                      className={classes.sharedWith}
                      style={styles.sharedWithStyle}
                    >
                      <div
                        data-test-id="journal-postcreation-sharedwith-icon"
                        className={classes.iconContainer}
                      >
                        {sharedWithDetails.icon}
                      </div>
                      <div
                        data-test-id="journal-postcreation-sharedwith-text"
                        className={classes.tagSubText}
                      >
                        {sharedWithDetails.text}
                      </div>
                    </div>
                  </Tag>
                </div>
              ) : (
                <span className={classes.sharedWithContainer}>
                  <span data-test-id="journal-postcreation-sharedwith-icon">
                    {sharedWithDetails.icon}
                  </span>
                  <span
                    className={classes.sharedWithText}
                    data-test-id="journal-postcreation-sharedwith-text"
                  >
                    {sharedWithDetails.text}
                  </span>
                </span>
              )
            }
            showEditIcon={!isPortfolioParityEnabled()}
            handleClick={() => goToStep("SHARE_WITH")}
            containerStyle={
              isPortfolioParityEnabled()
                ? styles.sharedWithContainerStyle
                : BLANK_OBJECT
            }
            flexContainerStyle={
              isPortfolioParityEnabled()
                ? styles.sharedWithFlexContainerStyle
                : BLANK_OBJECT
            }
            testId="journal-postcreation-sharedwith"
          />
        </div>
        <ManageFoldersModal
          onClose={onManageFolderModalClose}
          courseFolders={courseTags}
          isOpen={showManageFoldersModal}
          setCreateFolderOnModalOpen={setCreateFolderOnModalOpen}
          createFolderOnModalOpen={createFolderOnModalOpen}
          courseIdFromParent={courseId}
        />
        {!!currentDialogAction &&
        isPortfolioParityEnabled() &&
        isPortfolioReviewSetupEnabled() ? (
          <DialogueBoxV3
            modalTitle={t(DIALOGS_INFO[currentDialogAction].title)}
            showModal={true}
            onClickButton2={comment => onDialogConfirmClick(comment)}
            modalBody={t(DIALOGS_INFO[currentDialogAction].message)}
            modalTitleSubText={
              showPromptDetail
                ? DIALOGS_INFO[currentDialogAction].titleSubText({
                    t,
                    name: currentDialogPostCreatorName,
                  })
                : ""
            }
            toggleDialogueBoxDisplay={OnToggleDialogueClick}
            button1={
              t(DIALOGS_INFO[currentDialogAction].cancelButtonText) ||
              t("common:cancel")
            }
            button2={t(DIALOGS_INFO[currentDialogAction].confirmButtonText)}
            isPromptBox={DIALOGS_INFO[currentDialogAction].isPromptBox}
            promptBoxType={DIALOGS_INFO[currentDialogAction].promptBoxType}
            promptDetail={
              showPromptDetail
                ? DIALOGS_INFO[currentDialogAction].promptDetail({ t })
                : DIALOGS_INFO[currentDialogAction].promptDetail
            }
            warningText={
              showPromptDetail &&
              _.has(DIALOGS_INFO[currentDialogAction], "warningText")
                ? DIALOGS_INFO[currentDialogAction].warningText({
                    t,
                    name: currentDialogPostCreatorName,
                  })
                : null
            }
            size={DIALOGS_INFO[currentDialogAction].size}
            button1Props={DIALOGS_INFO[currentDialogAction].button1Props}
            button2Props={DIALOGS_INFO[currentDialogAction].button2Props}
            warningTextStyles={
              DIALOGS_INFO[currentDialogAction].warningTextStyles
            }
            headerStyles={headerStyles}
            modalBodyStyle={
              _.isEqual(currentDialogAction, "REJECT_POST")
                ? { padding: "0px 32px" }
                : { padding: "16px 32px" }
            }
            textAreaRows={_.get(
              DIALOGS_INFO[currentDialogAction],
              "textAreaRows",
              3
            )}
            showAlert={_.isEqual(currentDialogAction, "APPROVE_WITH_COMMENT")}
            showLabel={!_.isEqual(currentDialogAction, "REJECT_POST")}
          />
        ) : null}
        {showEditAttachmentModal ? (
          <EditAttachmentModal
            attachments={getEditModalAttachments(nonAudioAttachments)}
            updatePost={updatePost}
            setToastMsg={setToastMsg}
            onClose={onEditAttachmentModalClose}
            onDoneClick={onEditAttachmentModalDoneClick}
            setPostAttachments={_.noop}
            showEditAttachmentModal={showEditAttachmentModal}
            studentActivityData={studentActivityData}
            studentIds={studentIds}
            selectedStudentForActivity={selectedStudentForActivity}
            isActivityPost={true}
          />
        ) : null}
        {showMediaModal && _.size(nonAudioAttachments) ? (
          <TheatreModeV2
            mediaAttachments={theatreModeAttachments}
            activeAttachmentIndex={currentAttachmentIndex}
            toggleTheatreMode={toggleMediaModal}
            iframeIdSelector={"workbook-iframe-dp-journal"}
            onDiscardDirectly={hideMediaModal}
            onReorderClick={setEditAttachmentModal}
            onDeleteMedia={onDeleteMedia}
            toolbarHeaderStyle={styles.toolbarHeaderStyles}
            showAttachmentCounter={true}
            reorderButtonTooltip={t("journal:reorder_tooltip")}
            setCurrentAttachmentIndex={
              selectedStudentForActivity === "ALL"
                ? _.noop
                : setCurrentAttachmentIndex
            }
            showReorderAndDeleteAttachmentIcon={true}
            updateCurrentActiveIndex={updateCurrentActiveIndex}
          />
        ) : null}
      </ScreenPanel>
    </>
  );
};

const getStudentFilters = _.memoize(
  ({ studentListFilters, selectedStudentIdsFromFilter }) => {
    return {
      ...studentListFilters,
      studentIds: [selectedStudentIdsFromFilter],
    };
  },
  ({ studentListFilters, selectedStudentIdsFromFilter }) => {
    return JSON.stringify({
      studentId: selectedStudentIdsFromFilter,
      academicYearId: _.get(studentListFilters, "academicYear"),
    });
  }
);

const mapStateToProps = (state, ownProps) => {
  const userInfo = getUserInfo();
  const defaultStudentNameOrderPreference = getDefaultStudentNameOrderPreference(
    state
  );
  const courseIdFromParent = _.get(
    ownProps,
    "screenPanelProps.postDetails.courseId"
  );
  const postPermissionData = getSettingValue({
    name:
      userInfo.user_type === "student"
        ? "GradeWisePortfolioAttachmentTypesStudent"
        : "GradeWisePortfolioAttachmentTypesEducator",
    courseId:
      _.get(state, "teacher.selected_class.selected_course") ||
      courseIdFromParent,
  });
  const postPermissionMediaOptions = [];
  _.forEach(_.get(postPermissionData, "data"), (key, value) => {
    const parsedKey = JSON.parse(key);
    if (_.includes(["food", "nap", "toilet"], value)) {
      parsedKey &&
        postPermissionMediaOptions.push(`ACTIVITY_${_.toUpper(value)}`);
    } else if (value === "audio" && parsedKey) {
      postPermissionMediaOptions.push("VOICE");
    } else
      parsedKey &&
        value !== "collage" &&
        postPermissionMediaOptions.push(_.toUpper(value));
  });
  const portfolioType = _.get(postPermissionData, "type");
  const defaultGrade = _.get(
    state,
    "post.postDetails.course.primaryGrade.id",
    null
  );
  const selectedStudentIdsFromFilter = _.get(
    state,
    "journal.filters.studentIds",
    ""
  );
  const currentAcademicYear = getCurrentAcademicYear({
    organizationId: state.login.userInfo.org_id,
  });

  const isGlobalHeaderVisible = _.get(
    state,
    "login.globalHeader.isVisible",
    false
  );

  const isCurrentAcademicYearSelected =
    _.get(state, "platform.academicYearSelected.isCurrentAcademicYear", true) ||
    getSettingValue({
      name: "EnablePreviousAYPostCreation",
      userId: userInfo.id,
      readFromUserAndOrgLevel: true,
    });

  return {
    creatorDetails: {
      id: userInfo.id,
      name: getFormattedUserName({
        user: {
          firstName: _.get(userInfo, "first_name"),
          lastName: _.get(userInfo, "last_name"),
          middleName: _.get(userInfo, "middle_name"),
          type: "staff",
        },
      }),
      profileImage: userInfo.profile_image,
    },
    organizationId: userInfo.org_id,
    filters: {
      criteriaType: _.get(ownProps, "activityType"),
      curriculumProgramIds: _.compact([
        getSelectedCurriculumId(state) ??
          _.get(ownProps, "screenPanelProps.curriculumProgramIdFromProps"),
      ]),
    },
    userType: userInfo.user_type,
    isData: true,
    isLoading: false,
    courseId:
      _.get(state, "teacher.selected_class.selected_course") ||
      courseIdFromParent,
    /* { creationAlert: boolean, previewAlert: { families: boolean, students: boolean, public: boolean } } */
    alertVisiblitySettings:
      getSettingValue({
        name: "TeacherPortal:ClosedActivityTrackingInfoModal",
        userId: userInfo.id,
        organizationId: userInfo.org_id,
        courseId:
          _.get(state, "teacher.selected_class.selected_course") ||
          courseIdFromParent,
        readFromUserAndOrgLevel: true,
      }) || {},
    defaultStudentNameOrderPreference,
    postPermissionData,
    portfolioType,
    postPermissionMediaOptions,
    defaultGrade,
    selectedStudentIdsFromFilter,
    studentFilers: getStudentFilters({
      studentListFilters: _.merge(_.get(state, "post.studentListFilters", {}), {
        academicYear: getSelectedAcademicYearId(state),
      }),
      selectedStudentIdsFromFilter,
    }),
    postId: _.get(state, "post.postDetails.id", null),
    academicYearId: _.get(currentAcademicYear, "id", undefined),
    isGlobalHeaderVisible,
    isCurrentAcademicYearSelected,
    userId: userInfo?.id,
    curriculumProgramIdFromProps: _.get(
      ownProps,
      "screenPanelProps.curriculumProgramIdFromProps"
    ),
  };
};

const mapActionCreators = {
  setToastMsg,
  updateSettings,
  enableGlobalHeader,
  disableGlobalHeader,
  updatePostStatusV2,
  updatePostStatus,
  removeProgressElement,
  downloadFromUrl,
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: ["project", "journal", "common", "toastMsgs"] }),
  // Following Query fetches criterias and its values based on activity ( i.e. For Food Meal type -> breakfast, lunch, etc.)
  graphql(getStudentActivityCriteriaSetsQuery, {
    name: "getStudentActivityCriteriaSets",
    skip: ({
      organizationId,
      activityType,
      filters,
      curriculumProgramIdFromProps,
    }) =>
      _.isNil(organizationId) ||
      _.isNil(activityType) ||
      _.isEmpty(filters?.curriculumProgramIds)
        ? _.isEmpty(curriculumProgramIdFromProps)
        : _.isEmpty(filters?.curriculumProgramIds),
    options: ({ organizationId, filters }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        organizationId: organizationId,
        filters: filters,
      },
    }),
    props({
      getStudentActivityCriteriaSets,
      ownProps: { organizationId, filters, isData, isLoading },
    }) {
      const data = getStudentActivityCriteriaSetsFromCache({
        organizationId,
        filters,
      });
      const activityCriteriaSets = _.get(
        data,
        "constants.academicCriteriaSets",
        []
      );
      return {
        getStudentActivityCriteriaSets,
        activityCriteriaSets,
        isLoading:
          _.includes(
            [1, 2],
            _.get(getStudentActivityCriteriaSets, "networkStatus")
          ) || isLoading,
        isData: !_.isEmpty(data) && isData,
      };
    },
  }),
  graphql(getCourseFolders, {
    name: "getCourseFolders",
    skip: ({ courseId }) =>
      _.isNil(courseId) || _.isEmpty(courseId) || !isPortfolioParityEnabled(),
    options: ({ courseId }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        courseId: courseId,
      },
    }),
    props({ getCourseFolders, ownProps: { courseId } }) {
      const data = getCourseFoldersFromCache(courseId);

      return {
        courseTags: _.get(data, "folders", BLANK_ARRAY),
        networkStatus: getCourseFolders.networkStatus,
        isLoading:
          getCourseFolders["networkStatus"] == 1 ||
          getCourseFolders["networkStatus"] == 2,
      };
    },
  }),
  graphql(getCourseFilteredStudentQuery, {
    name: "getCourseFilteredStudent",
    skip: ({ selectedStudentIdsFromFilter, userType, courseId }) =>
      !selectedStudentIdsFromFilter ||
      !isPortfolioParityEnabled() ||
      userType === "student" ||
      !courseId,
    options: ({
      courseId,
      studentFilers,
      postId,
      defaultNameSortPreference,
      academicYearId,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: courseId,
        filters: getUpdatedArchivedFilters(studentFilers, {
          entityType: "JOURNAL",
          entityId: postId,
        }),
        orderBy: defaultNameSortPreference,
        orderByDirection: ASC,
        userArchivedFilters: { academicYearId },
      },
    }),
    props({
      getCourseFilteredStudent,
      ownProps: {
        courseId,
        studentFilers,
        postId,
        defaultNameSortPreference,
        academicYearId,
      },
    }) {
      const data = getCourseFilteredStudentFromCache({
        courseId,
        filters: getUpdatedArchivedFilters(studentFilers, {
          entityType: "JOURNAL",
          entityId: postId,
        }),
        orderBy: defaultNameSortPreference,
        orderByDirection: ASC,
        userArchivedFilters: { academicYearId },
      });
      return {
        isData: !_.isEmpty(data),
        studentEdges: _.get(data, "students.edges", BLANK_ARRAY),
        networkStatus: getCourseFilteredStudent.networkStatus,
        isLoading:
          getCourseFilteredStudent["networkStatus"] == 1 ||
          getCourseFilteredStudent["networkStatus"] == 2,
      };
    },
  }),
  graphql(getConfigurationQuery, {
    name: "getConfigurationQuery",
    skip: ({ defaultGrade }) =>
      !isPortfolioReviewSetupEnabledAndIsReviewRoute() || !defaultGrade,
    options: ({ defaultGrade }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        configurationEntityGroupFilters: createConfigurationFilters([
          defaultGrade,
        ]),
        isAdminPage: true,
        isSettingsPage: false,
      },
    }),
    props: ({
      getConfigurationQuery,
      ownProps: { isLoading, isData, defaultGrade },
    }) => {
      const postPermissionData = JSON.parse(
        _.get(
          getConfigurationQuery,
          "platform.configuration[0].configurations[1].value"
        ) || "{}"
      );
      const postPermissionMediaOptions = [];
      _.forEach(_.get(postPermissionData, "data"), (key, value) => {
        const parsedKey = JSON.parse(key);
        if (_.includes(["food", "nap", "toilet"], value)) {
          parsedKey &&
            postPermissionMediaOptions.push(`ACTIVITY_${_.toUpper(value)}`);
        } else if (value === "audio" && parsedKey) {
          postPermissionMediaOptions.push("VOICE");
        } else
          parsedKey &&
            value !== "collage" &&
            postPermissionMediaOptions.push(_.toUpper(value));
      });
      const portfolioType = _.get(postPermissionData, "type");
      return {
        isData,
        isLoading:
          getConfigurationQuery["networkStatus"] == 1 ||
          getConfigurationQuery["networkStatus"] == 2 ||
          isLoading,
        postPermissionMediaOptions,
        portfolioType,
      };
    },
  }),
  withLoader
)(ManageStudentActivity);
